import { Injectable } from "@angular/core";
import { CallService } from "../data/callService";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ConfigService } from "./config.service";
import { AuthService } from "../auth/auth.service";
import { environment } from "environments/environment";
import { Catalogo } from "app/oDres/modelos/Catalogos/catalogo";
import { CentroCosto } from "app/oDres/modelos/Catalogos/centroCosto";
import { Clasificacion } from "app/oDres/modelos/Catalogos/clasificacion";
import { CodigoOrigen } from "app/oDres/modelos/Catalogos/codigoOrigen";
import { ConceptoPago } from "app/oDres/modelos/Catalogos/conceptoPago";
import { Conceptos } from "app/oDres/modelos/Catalogos/conceptos";
import { CuentaContable } from "app/oDres/modelos/Catalogos/cuentaContable";
import { Grupos } from "app/oDres/modelos/Catalogos/grupos";
import { Impuesto } from "app/oDres/modelos/Catalogos/impuesto";
import { ListaPrecio } from "app/oDres/modelos/Empresa/listaPrecio";
import { Modulo } from "app/oDres/modelos/Catalogos/modulo";
import { Moneda } from "app/oDres/modelos/Catalogos/moneda";
import { AreaGeografica } from "app/oDres/modelos/Catalogos/Nomina/areaGeografica";
import { Perfil } from "app/oDres/modelos/Catalogos/perfil";
import { PerfilEmpresa } from "app/oDres/modelos/Catalogos/perfilEmpresa";
import { Producto } from "app/oDres/modelos/Catalogos/producto";
import { Tercero } from "app/oDres/modelos/Catalogos/tercero";
import { TipoMovimiento } from "app/oDres/modelos/Catalogos/tipoMovimiento";
import { TipoTransaccion } from "app/oDres/modelos/Catalogos/tipoTransaccion";
import { TipoTransaccionBase } from "app/oDres/modelos/Catalogos/tipoTransaccionBase";
import { UnidadMedida } from "app/oDres/modelos/Catalogos/unidadMedida";
import { ContabilizarModulos } from "app/oDres/modelos/Contabilidad/contabilizarModulos";
import { CorreoCRM } from "app/oDres/modelos/CRM/CorreoCRM";
import { JsonResponse } from "app/oDres/modelos/Datos/jsonResponse";
import { Bancos } from "app/oDres/modelos/Empresa/banco";
import { Bodega } from "app/oDres/modelos/Empresa/bodega";
import { CertificadosCSDEmpresa } from "app/oDres/modelos/Empresa/certificadosCSDEmpresa";
import { Comprador } from "app/oDres/modelos/Empresa/comprador";
import { Consecutivo } from "app/oDres/modelos/Empresa/consecutivo";
import { ContratoProyecto } from "app/oDres/modelos/Empresa/contratoProyecto";
import { DetallePerfil } from "app/oDres/modelos/Empresa/detallePerfil";
import { DocumentoXContratoProyecto } from "app/oDres/modelos/Empresa/documentoXContratoProyecto";
import { DocumentoXProducto } from "app/oDres/modelos/Empresa/documentoXProducto";
import { DocumentoXProyecto } from "app/oDres/modelos/Empresa/documentoxProyecto";
import { Empresa } from "app/oDres/modelos/Empresa/empresa";
import { EmpresaMoneda } from "app/oDres/modelos/Empresa/empresaMoneda";
import { HistorialUsoTimbres } from "app/oDres/modelos/Empresa/historialUsoTimbres";
import { ImagenesEmpresa } from "app/oDres/modelos/Empresa/imagenesEmpresa";
import { ImpuestosxEmpresa } from "app/oDres/modelos/Empresa/impuestosxEmpresa";
import { Lotes } from "app/oDres/modelos/Empresa/lotes";
import { MonedaXEmpresa } from "app/oDres/modelos/Empresa/monedaXEmpresa";
import { Proyecto } from "app/oDres/modelos/Empresa/proyecto";
import { RegistroOrdenesCompraEmpresa } from "app/oDres/modelos/Empresa/registroOrdenesCompraEmpresa";
import { TipoLicencia } from "app/oDres/modelos/Empresa/tipoLicencia";
import { TipoMovBancos } from "app/oDres/modelos/Empresa/tipoMovBancos";
import { Usuario } from "app/oDres/modelos/Empresa/usuarios";
import { Vendedor } from "app/oDres/modelos/Empresa/vendedor";
import { AreaLaboral } from "app/oDres/modelos/RH/AreaLaboral";
import { Cargo } from "app/oDres/modelos/RH/cargo";
import { RegistroPatronal } from "app/oDres/modelos/RH/registroPatronal";
import { MedioElectronico } from "app/oDres/modelos/Timbrado/medioElectronico";
import { FuncionesNomina } from 'app/oDres/modelos/Catalogos/Nomina/funcionesNomina';
import { SubGrupoEmpresa } from 'app/oDres/modelos/Nomina/subgrupoEmpresa';
import { Menu } from "app/oDres/modelos/Catalogos/menu";
import { ConfiguracionGlobal } from "app/oDres/modelos/Sistemas/configuracionGlobal";
import { SubGrupo } from "app/oDres/modelos/Catalogos/subGrupo";
import { TipoVariable } from "app/oDres/modelos/Sistemas/tipoVariable";
import { Tareas } from "app/oDres/modelos/Empresa/tareas";
import { TareasXDocumento } from "app/oDres/modelos/Empresa/tareasXDocumento";
import { EstatusTarea } from "app/oDres/modelos/Catalogos/estatusTarea";
import { Chats } from "app/oDres/modelos/Generales/chats";
import { PagoProveedorCompleto } from "app/oDres/modelos/PagoProveedor/pagoProveedorCompleto";
import { PagoClienteCompleto } from "app/oDres/modelos/Cobranza/pagoClienteCompleto";
import { Documento } from "app/oDres/modelos/Empresa/documento";
import { Banco } from "app/oDres/modelos/Catalogos/banco";
import { ConsecutivoCodigoBanco } from "app/oDres/modelos/Bancos/consecutivoCodigoBanco";
import { AsyncSubject, Observable } from "rxjs";
import { TareasXNotas } from "app/oDres/modelos/Empresa/tareasXNotas";
import { TerceroPaginado } from "app/oDres/modelos/Catalogos/terceroPaginado";
import { CatalogoPagosCobranza } from "app/oDres/modelos/Empresa/catalogoPagosCobranza";
import { CatalogoPagosProveedor } from "app/oDres/modelos/Empresa/catalogosPagosProveedor";
import { MovimientoBancos } from "app/oDres/modelos/Bancos/movimientoBancos";
import { CatalogoMovimientosBancarios } from "app/oDres/modelos/Catalogos/catalogosMovimientosBancarios";
import { CatalogoSaldoBancos } from "app/oDres/modelos/Catalogos/catalogosSaldoBancos";
import { CatalogoBusquedaDocumentosVentas } from "app/oDres/modelos/Catalogos/catalogoBusquedaDocumentosVentas";
import { TransaccionComercial } from "app/oDres/modelos/Empresa/transaccionComercial";
import { SaldoAlmacen } from "app/oDres/modelos/Empresa/saldoAlmacen";
import { TransaccionComercialCompleta } from "app/oDres/modelos/Empresa/transaccionComercialCompleta";
import { DocumentoXML } from "app/oDres/modelos/Generales/documentoXML";
import { VincularXMLDocumentos } from "app/oDres/modelos/Empresa/vincularXMLDocumentos";
import { TransaccionComercialPaginado } from "app/oDres/modelos/Empresa/transaccionComercialPaginado";
import { CobranzaGeneral } from "app/oDres/modelos/Empresa/cobranzaGeneral";
import { CatalogoDocumentoVentas } from "app/oDres/modelos/Catalogos/catalogoDocumentosVentas";
import { TasaConversion } from "app/oDres/modelos/Empresa/tasaConversion";
import { RelacionesSAT } from "app/oDres/modelos/Empresa/relacionesSAT";
import { MtSATMotivoCancela } from "app/oDres/modelos/Catalogos/MtSATMotivoCancela";
import { CatalogoCobranza } from "app/oDres/modelos/Empresa/catalogoCobranza";
import { PagoClienteComplemento } from "app/oDres/modelos/Cobranza/pagoClienteComplemento";
import { PagoCliente } from "app/oDres/modelos/Cobranza/pagoCliente";
import { ConfiguracionGlobalEmpresa } from "app/oDres/modelos/Empresa/configuracionGlobalEmpresa";
import { CatalogoBusquedaDocumentosInventario } from "app/oDres/modelos/Catalogos/catalogoBusquedaDocumentosInventario";
import { CatalogoMovimientoAlmacen } from "app/oDres/modelos/Catalogos/catalogoMovimientoAlmacen";
import { CatalogoSaldoInventarios } from "app/oDres/modelos/Catalogos/catalogosSaldoInventarios";
import { ListaPrecioCompleto } from "app/oDres/modelos/Empresa/listaPrecioCompleta";
import { ListaPrecioProducto } from "app/oDres/modelos/Empresa/listaPrecioProducto";
import { CatalogoBusquedaDocumentosCompras } from "app/oDres/modelos/Catalogos/catalogoBusquedaDocumentosCompra";
import { CARGARXML } from "app/oDres/modelos/Generales/cargarXML";
import { CatalogoComprasEgresos } from "app/oDres/modelos/Catalogos/catalogoComprasEgresos";
import { Ciudad } from "app/oDres/modelos/Empresa/ciudad";
import { TasaCambioCatalogo } from "app/oDres/modelos/Sistemas/tasaCambioCatalogo";
import { TransaccionComercialCompletaActualizar } from "app/oDres/modelos/Empresa/transaccionComercialCompletoActualizar";
import { Pais } from "app/oDres/modelos/Catalogos/pais";
import * as moment from 'moment';
import { TipoMovBancosXBanco } from "app/oDres/modelos/Empresa/tipoMovBancosXBanco";
import { CatalogoCuentasPagar } from "app/oDres/modelos/Catalogos/catalogoCuentasPagar";
import { PagoProveedorDetalle } from "app/oDres/modelos/PagoProveedor/pagoProveedorDetalle";
import { PagoProveedor } from "app/oDres/modelos/PagoProveedor/pagoProveedor";
import { TimbradoPagoCliente } from "app/oDres/modelos/Cobranza/timbradoPagoCliente";
import { CatalogoComprobantesPolizas } from "app/oDres/modelos/Catalogos/catalogosComprobantesPolizas";
import { MovimientoContableAgrupado } from "app/oDres/modelos/Empresa/movimientoContableAgrupado";
import { AgregarRemoverTimbres } from "app/oDres/modelos/Empresa/agregarRemoverTimbres";
import { EmpresaConfiguracionImagenes } from "app/oDres/modelos/Empresa/empresaConfiguracionImagenes";
import { JsonResponseDireccion } from "app/oDres/modelos/Datos/jsonResponseDireccion";
import { ClavePedimento } from "app/oDres/modelos/Catalogos/clavePedimento";
import { ClaveIncoterm } from "app/oDres/modelos/Catalogos/claveIncoterm";
import { TransaccionComercialDetalle } from "app/oDres/modelos/Empresa/transaccionComercialDetalle";

export interface SelectedFiles {
    id?: number;
    name: string;
    file: any;
    base64?: string;
    url?: string;
}

@Injectable({
    providedIn: 'root'
})
export class GeneralesService extends CallService {

    listaTercero: TerceroPaginado[];
    TipoTransaccion = '';
    PerfilEmpresaBusqueda: PerfilEmpresa = null;

    terceroBusqueda: Tercero = null;
    ProductoBusqueda: Producto = null;
    CompradorBusqueda: Comprador = null;
    bancoBusqueda: Banco = null;
    VendedorBusqueda: Vendedor = null;
    descripcionMenu = '';
    esClienteOProveedor: string = null;

    catalogosPagosCobranza: CatalogoPagosCobranza;
    catalogosPagosProveedor: CatalogoPagosProveedor;

    PerfilBusqueda: Perfil = null;

    ListaMovimientosBancarios: MovimientoBancos[] = [];
    catalogoMovimientosBancarios: CatalogoMovimientosBancarios;
    catalogoSaldoBancos: CatalogoSaldoBancos;

    catalogoBusquedaDocumentosVenta: CatalogoBusquedaDocumentosVentas;
    identificadorClienteProveedor: string = null;
    transaccionComercialCompleta: TransaccionComercialCompleta = {} as TransaccionComercialCompleta;
    transaccionComercialCompletaCopia: TransaccionComercialCompleta = {} as TransaccionComercialCompleta;
    catalogosDocumentosVentas: CatalogoDocumentoVentas;

    catalogosCobranza: CatalogoCobranza;

    catalogoBusquedaDocumentosInventario: CatalogoBusquedaDocumentosInventario;
    transaccionComercialPaginadoEditar: TransaccionComercialCompleta;
    catalogosMovimientoAlmacen: CatalogoMovimientoAlmacen;
    catalogoSaldoInventarios: CatalogoSaldoInventarios;

    catalogoBusquedaDocumentosCompras: CatalogoBusquedaDocumentosCompras;
    catalogoComprasEgresos: CatalogoComprasEgresos;

    fileChangedEvent: any = '';
    fileName = '';

    loteBusqueda: Lotes = null;

    catalogosCuentasPagar: CatalogoCuentasPagar;

    catalogoComprobantePoliza: CatalogoComprobantesPolizas;
    movimientoContableAgrupadoEditar: MovimientoContableAgrupado = {};

    private urls = {
        obtenerListaModulos: environment.urlApi + '/externo/api/modulo/obtener-Modulo',
        obtenerListaModulosXMenuLicencia: environment.urlApi + '/externo/api/modulo/obtener-ModuloXMenuXLicencia',
        obtenerCatalogosModulo: environment.urlApi + '/externo/api/catalogos/obtener-catalogos-modulo',
        obtenerBodegas: environment.urlApi + '/externo/api/bodega/obtener-Bodega',
        obtenerBodegasPaginado: environment.urlApi + '/externo/api/bodega/obtener-paginado-Bodega',
        obtenerCuentaContable: environment.urlApi + '/externo/api/cuentaContable/obtener-Documento-contable',
        obtenerCuentaContablePaginado: environment.urlApi + '/externo/api/cuentaContable/obtener-PaginadoCuentaContable',
        agregarCuentaContable: environment.urlApi + '/externo/api/cuentaContable/agregar-Documento-contable',
        actualizarCuentaContable: environment.urlApi + '/externo/api/cuentaContable/actualizar-Documento-contable',
        obtenerCodigoOrigen: environment.urlApi + '/externo/api/CodigoOrigen/obtener-codigoOrigen',
        obtenerConsecutivo: environment.urlApi + '/externo/api/consecutivo/obtener-Consecutivo',
        obtenerConsecutivoPaginado: environment.urlApi + '/externo/api/consecutivo/obtener-paginado-Consecutivo',
        obtenerConsecutivoParaVincular: environment.urlApi + '/externo/api/consecutivo/obtener-ConsecutivoParaVincular',
        obtenerConsecutivosParaVincularDisponibles: environment.urlApi + '/externo/api/consecutivo/obtener-ConsecutivosParaVincularDisponibles',
        obtenerConceptoPago: environment.urlApi + '/externo/api/ConceptoPago/obtener-ConceptoPago',
        obtenerConceptoPagoPaginado: environment.urlApi + '/externo/api/ConceptoPago/obtener-paginado-ConceptoPago',
        obtenerTipoMovBancos: environment.urlApi + '/externo/api/TipoMovBancos/obtener-TipoMovBancos',
        obtenerTipoMovBancosXEmpresa: environment.urlApi + '/externo/api/TipoMovBancos/obtener-TipoMovBancosXEmpresa',
        obtenerTipoMovBancosXBanco: environment.urlApi + '/externo/api/TipoMovBancosXBanco/obtener-TipoMovBancosXBanco',
        obtenerClasificacion: environment.urlApi + '/externo/api/clasificacion/obtener-Clasificacion',
        obtenerClasificacionPaginado: environment.urlApi + '/externo/api/clasificacion/obtener-paginado-Clasificacion',
        obtenerMoneda: environment.urlApi + '/externo/api/moneda/obtener-Moneda',
        obtenerMonedaXEmpresa: environment.urlApi + '/externo/api/monedaXEmpresa/obtener-Moneda-Empresa',
        obtenerUnidadMedida: environment.urlApi + '/externo/api/unidadmedida/obtener-UnidadMedida',
        obtenerListaPrecio: environment.urlApi + '/externo/api/listaprecio/obtener-listaprecio',
        obtenerListaPrecioProducto: environment.urlApi + '/externo/api/ListaPrecioProducto/obtener-ListaPrecioProducto',
        obtenerListaPrecioProductoXProducto: environment.urlApi + '/externo/api/ListaPrecioProducto/obtener-ListaPrecioProductoXProducto',
        obtenerTipoMovimiento: environment.urlApi + '/externo/api/tipoMovimiento/obtener-tipoMovimiento',
        obtenerTipoTransaccion: environment.urlApi + '/externo/api/tipoTransaccion/obtener-TipoTransaccion',
        obtenerTipoTransaccionPaginado: environment.urlApi + '/externo/api/tipoTransaccion/obtener-paginado-TipoTransaccion',
        obtenerTipoTransaccionBase: environment.urlApi + '/externo/api/tipoTransaccionBase/obtener-TipoTransaccionBase',
        agregarBodega: environment.urlApi + '/externo/api/bodega/agregar-Bodega',
        agregarConsecutivo: environment.urlApi + '/externo/api/consecutivo/agregar-Consecutivo',
        agregarTipoMovBancos: environment.urlApi + '/externo/api/TipoMovBancos/agregar-TipoMovBancos',
        agregarTipoMovBancosXBanco: environment.urlApi + '/externo/api/TipoMovBancos/agregar-TipoMovBancosXBanco',
        eliminarTipoMovBancosXBanco: environment.urlApi + '/externo/api/TipoMovBancos/eliminar-TipoMovBancosXBanco',
        agregarConceptoPago: environment.urlApi + '/externo/api/ConceptoPago/agregar-ConceptoPago',
        actualizarBodega: environment.urlApi + '/externo/api/bodega/actualizar-Bodega',
        actualizarConsecutivo: environment.urlApi + '/externo/api/consecutivo/actualizar-Consecutivo',
        actualizarTipoMovBancos: environment.urlApi + '/externo/api/TipoMovBancos/actualizar-TipoMovBancos',
        actualizarTipoMovBancosXBancoLista: environment.urlApi + '/externo/api/TipoMovBancosXBanco/actualizar-TipoMovBancosXBancoLista',
        actualizarConceptoPago: environment.urlApi + '/externo/api/ConceptoPago/actualizar-ConceptoPago',
        agregarClasificacion: environment.urlApi + '/externo/api/clasificacion/agregar-Clasificacion',
        actualizarclasificacion: environment.urlApi + '/externo/api/clasificacion/actualizar-Clasificacion',
        agregarListaPrecioCompleto: environment.urlApi + '/externo/api/listaprecio/agregar-listaprecio-completo',
        actualizarListaPrecioCompleto: environment.urlApi + '/externo/api/listaprecio/actualizar-listaprecio-completo',
        agregarUnidadMedida: environment.urlApi + '/externo/api/unidadmedida/agregar-UnidadMedida',
        actualizarUnidadMedida: environment.urlApi + '/externo/api/unidadmedida/actualizar-UnidadMedida',
        agregarTipoMovimiento: environment.urlApi + '/externo/api/tipoMovimiento/agregar-tipoMovimiento',
        actualizarTipoMovimiento: environment.urlApi + '/externo/api/tipoMovimiento/actualizar-tipoMovimiento',
        agregarTipoTransaccion: environment.urlApi + '/externo/api/tipoTransaccion/agregar-tipoTransaccion',
        actualizarTipoTransaccion: environment.urlApi + '/externo/api/tipoTransaccion/actualizar-tipoTransaccion',
        agregarEmpresaMoneda: environment.urlApi + '/externo/api/empresaMoneda/agregar-EmpresaMoneda',
        actualizarEmpresaMoneda: environment.urlApi + '/externo/api/empresaMoneda/actualizar-EmpresaMoneda',
        obtenerBancos: environment.urlApi + '/externo/api/bancos/obtener-Bancos',
        obtenerPaginadoBancos: environment.urlApi + '/externo/api/bancos/obtener-paginado-Bancos',
        obtenerLotes: environment.urlApi + '/externo/api/Lotes/obtener-Lotes',
        obtenerPaginadoLotes: environment.urlApi + '/externo/api/Lotes/obtener-Paginado-Lotes',
        agregarLotes: environment.urlApi + '/externo/api/Lotes/agregar-Lotes',
        actualizarLotes: environment.urlApi + '/externo/api/Lotes/actualizar-Lotes',
        obtenerCentroCostos: environment.urlApi + '/externo/api/CentroCosto/obtener-CentroCosto',
        obtenerCentroCostosPaginado: environment.urlApi + '/externo/api/CentroCosto/obtener-paginado-CentroCosto',
        agregarCentroCostos: environment.urlApi + '/externo/api/CentroCosto/agregar-CentroCosto',
        actualizarCentroCostos: environment.urlApi + '/externo/api/CentroCosto/actualizar-CentroCosto',
        obtenerImpuestosxEmpresa: environment.urlApi + '/externo/api/ImpuestosxEmpresa/obtener-ImpuestosxEmpresa',
        obtenerImpuestosxEmpresaPaginado: environment.urlApi + '/externo/api/ImpuestosxEmpresa/obtener-paginado-ImpuestosxEmpresa',
        agregarImpuestosxEmpresa: environment.urlApi + '/externo/api/ImpuestosxEmpresa/agregar-ImpuestosxEmpresa',
        actualizarImpuestosxEmpresa: environment.urlApi + '/externo/api/ImpuestosxEmpresa/actualizar-ImpuestosxEmpresa',
        verificarimpuestoscatalogosempresa: environment.urlApi + '/externo/api/catalogos/verificar-impuestos-catalogos-empresa',
        obtenerImpuesto: environment.urlApi + '/externo/api/impuesto/obtener-Impuesto',
        obtenerImpuestosSinRegistrar: environment.urlApi + '/externo/api/impuesto/obtener-ImpuestosSinRegistrar',
        obtenerMenuCompleto: environment.urlApi + '/externo/api/menu/obtener-Menu-completo',
        obtenerMenuPerfiles: environment.urlApi + '/externo/api/menu/obtener-Menu-Perfiles',
        obtenerPerfil: environment.urlApi + '/externo/api/Perfil/obtener-Perfil',
        obtenerPerfilEmpresa: environment.urlApi + '/externo/api/PerfilEmpresa/obtener-PerfilEmpresa',
        actualizarPerfilEmpresa: environment.urlApi + '/externo/api/PerfilEmpresa/actualizar-PerfilEmpresa',
        obtenerPerfilPerfilEmpresa: environment.urlApi + '/externo/api/Perfil/obtener-Perfil-PerfilEmpresa',
        agregarUsuario: environment.urlApi + '/externo/api/usuario/agregar-Usuario',
        actualizarUsuario: environment.urlApi + '/externo/api/usuario/actualizar-Usuario',
        obtenerUsuario: environment.urlApi + '/externo/api/usuario/obtener-Usuario',
        obtenerUsuarioPaginado: environment.urlApi + '/externo/api/usuario/obtener-paginado-Usuario',
        agregarperfilEmpresaDetallePerfil: environment.urlApi + '/externo/api/DetallePerfil/agregar-perfilEmpresa-DetallePerfil',
        obtenerDetallePerfil: environment.urlApi + '/externo/api/DetallePerfil/obtener-DetallePerfil',
        obtenerPerfilEmpresaPaginado: environment.urlApi + '/externo/api/PerfilEmpresa/obtener-paginado-PerfilEmpresa',
        obtenerMedioElectronico: environment.urlApi + '/externo/api/MedioElectronico/obtener-MedioElectronico',
        obtenerAreaLaboral: environment.urlApi + '/externo/api/RH/AreaLaboral/obtener-AreaLaboral',
        obtenerAreaLaboralPaginado: environment.urlApi + '/externo/api/RH/AreaLaboral/obtener-paginado-AreaLaboral',
        agregarAreaLaboral: environment.urlApi + '/externo/api/RH/AreaLaboral/agregar-AreaLaboral',
        actualizarAreaLaboral: environment.urlApi + '/externo/api/RH/AreaLaboral/actualizar-AreaLaboral',
        obtenerCargo: environment.urlApi + '/externo/api/RH/Cargos/obtener-Cargos',
        obtenerCargoPaginado: environment.urlApi + '/externo/api/RH/Cargos/obtener-paginado-Cargos',
        agregarCargo: environment.urlApi + '/externo/api/RH/Cargos/agregar-Cargos',
        actualizarCargo: environment.urlApi + '/externo/api/RH/Cargos/actualizar-Cargos',
        obtenerConcepto: environment.urlApi + '/externo/api/Nomina/Conceptos/obtener-Conceptos',
        obtenerConceptoPaginado: environment.urlApi + '/externo/api/Nomina/Conceptos/obtener-paginado-Conceptos',
        agregarConceptosLiquidacionLista: environment.urlApi + '/externo/api/ConceptosLiquidacion/agregar-ConceptosLiquidacionLista',
        agregarConcepto: environment.urlApi + '/externo/api/Nomina/Conceptos/agregar-Conceptos',
        actualizarConcepto: environment.urlApi + '/externo/api/Nomina/Conceptos/actualizar-Conceptos',
        obtenerAreaGeografica: environment.urlApi + '/externo/api/CatalogoNomina/AreaGeografica/obtener-AreaGeografica',
        agregarAreaGeografica: environment.urlApi + '/externo/api/CatalogoNomina/AreaGeografica/agregar-AreaGeografica',
        actualizarAreaGeografica: environment.urlApi + '/externo/api/CatalogoNomina/AreaGeografica/actualizar-AreaGeografica',
        obtenerGrupos: environment.urlApi + '/externo/api/Grupos/obtener-Grupos',
        agregarGrupos: environment.urlApi + '/externo/api/Grupos/agregar-Grupos',
        actualizarGrupos: environment.urlApi + '/externo/api/Grupos/actualizar-Grupos',
        obtenerSubGrupoEmpresa: environment.urlApi + '/externo/api/SubGrupoEmpresa/obtener-SubGrupo',
        agregarSubGrupoEmpresa: environment.urlApi + '/externo/api/SubGrupoEmpresa/agregar-SubGrupo',
        actualizarSubGrupoEmpresa: environment.urlApi + '/externo/api/SubGrupoEmpresa/actualizar-SubGrupo',
        agregarContabilizarModulos: environment.urlApi + '/externo/api/ContabilizarModulos/agregar-ContabilizarModulos',
        actualizarEmpresa: environment.urlApi + '/externo/api/Empresa/actualizar-Empresa',
        actualizarEmpresaNombre: environment.urlApi + '/externo/api/Empresa/actualizar-Empresa-Nombre',
        agregarImagenesEmpresa: environment.urlApi + '/externo/api/ImagenesEmpresa/agregar-ImagenesEmpresa',
        actualizarImagenesEmpresa: environment.urlApi + '/externo/api/ImagenesEmpresa/actualizar-ImagenesEmpresa',
        agregarCertificadosCSDEmpresa: environment.urlApi + '/externo/api/CertificadosCSDEmpresa/agregar-CertificadosCSDEmpresa',
        actualizarCertificadosCSDEmpresa: environment.urlApi + '/externo/api/CertificadosCSDEmpresa/actualizar-CertificadosCSDEmpresa',
        cargoConRedireccionamientoRenovacionLicenciaXEmpresa: environment.urlApi + '/externo/api/RegistroOrdenesCompraEmpresa/cargo-ConRedireccionamientoRenovacionLicenciaXEmpresa',
        cargoConRedireccionamientoCompraTimbres: environment.urlApi + '/externo/api/RegistroOrdenesCompraEmpresa/cargo-ConRedireccionamientoCompraTimbres',
        obtenerEmpresa: environment.urlApi + '/externo/api/Empresa/obtener-Empresa',
        obtenerEmpresaCompleta: environment.urlApi + '/externo/api/Empresa/obtener-EmpresaCompleta',
        obtenerTipoLicencia: environment.urlApi + '/externo/api/TipoLicencia/obtener-TipoLicencia',
        obtenerCertificadosCSDEmpresa: environment.urlApi + '/externo/api/CertificadosCSDEmpresa/obtener-CertificadosCSDEmpresa',
        obtenerFuncionesNomina: environment.urlApi + '/externo/api/FuncionesNomina/obtener-FuncionesNomina',
        verificarCatalogosConsecutivo: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-consecutivos',
        verificarCatalogosTipoMovimiento: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-tipoMovimiento',
        actualizarProductoCuentaContable: environment.urlApi + '/externo/api/Producto/actualizar-Producto-CuentaContable',
        verificarCatalogosProducto: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-producto',
        verificarCatalogosInformacionEmpresa: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-informacionEmpresa',
        obtenerEmpresaInformacionLicencia: environment.urlApi + '/externo/api/Empresa/obtener-EmpresaInformacionLicencia',
        obtenerProducto: environment.urlApi + '/externo/api/Producto/obtener-Producto',
        obtenerCatalogoProductoListaPrecioAgregar: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-listaPrecios-agregar',
        obtenerCatalogoProductoListaPrecio: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-listaPrecios',
        obtenerProductoPaginado: environment.urlApi + '/externo/api/Producto/obtener-paginado-producto',
        actualizarProducto: environment.urlApi + '/externo/api/Producto/actualizar-Producto',
        obtenerTercero: environment.urlApi + '/externo/api/Tercero/obtener-Tercero',
        revisarTercero: environment.urlApi + '/externo/api/Tercero/revisar-Tercero',
        obtenerDireccionTercero: environment.urlApi + '/externo/api/Tercero/obtener-DireccionTercero',
        obtenerTerceroPaginado: environment.urlApi + '/externo/api/Tercero/obtener-paginado-Tercero',
        actualizarTercero: environment.urlApi + '/externo/api/Tercero/actualizar-Tercero',
        actualizarTerceroCuentaContable: environment.urlApi + '/externo/api/Tercero/actualizar-Tercero-CuentaContable',
        obtenerVendedor: environment.urlApi + '/externo/api/vendedor/obtener-Vendedor',
        obtenerVendedorPaginado: environment.urlApi + '/externo/api/vendedor/obtener-paginado-vendedor',
        obtenerVendedorXCliente: environment.urlApi + '/externo/api/vendedor/obtener-VendedorXCliente',
        obtenerCorreoCRM: environment.urlApi + '/externo/api/CRM/CorreoCRM/obtener-CorreoCRM',
        actualizarVendedor: environment.urlApi + '/externo/api/vendedor/actualizar-Vendedor',
        actualizarComprador: environment.urlApi + '/externo/api/Comprador/actualizar-Comprador',
        obtenerComprador: environment.urlApi + '/externo/api/Comprador/obtener-Comprador',
        obtenerCompradorPaginado: environment.urlApi + '/externo/api/Comprador/obtener-paginado-Comprador',
        obtenerPaginadoEmpresa: environment.urlApi + '/externo/api/Empresa/obtener-paginado-Empresa',
        obtenerHistorialUsoTimbres: environment.urlApi + '/externo/api/HistorialUsoTimbres/obtener-HistorialUsoTimbres',
        obtenerPaginadoHistorialUsoTimbres: environment.urlApi + '/externo/api/HistorialUsoTimbres/obtener-paginado-HistorialUsoTimbres',
        obtenerDomicilio: environment.urlApi + '/externo/api/Utilidades/obtener-Domicilio',
        obtenerProyecto: environment.urlApi + '/externo/api/Proyecto/obtener-Proyecto',
        obtenerPaginadoProyecto: environment.urlApi + '/externo/api/Proyecto/obtener-Paginado-Proyecto',
        agregarProyecto: environment.urlApi + '/externo/api/Proyecto/agregar-Proyecto',
        actualizarProyecto: environment.urlApi + '/externo/api/Proyecto/actualizar-Proyecto',
        obtenerContrato: environment.urlApi + '/externo/api/ContratoProyecto/obtener-ContratoProyecto',
        obtenerPaginadoContrato: environment.urlApi + '/externo/api/ContratoProyecto/obtener-Paginado-ContratoProyecto',
        agregarContrato: environment.urlApi + '/externo/api/ContratoProyecto/agregar-ContratoProyecto',
        actualizarContrato: environment.urlApi + '/externo/api/ContratoProyecto/actualizar-ContratoProyecto',
        agregarDocumentoXProyecto: environment.urlApi + '/externo/api/DocumentoXProyecto/agregar-DocumentoXProyecto',
        obtenerDocumentoXProyecto: environment.urlApi + '/externo/api/DocumentoXProyecto/obtener-DocumentoXProyecto',
        obtenerDocumentoXProyectoPaginado: environment.urlApi + '/externo/api/DocumentoXProyecto/obtener-paginado-DocumentoXProyecto',
        eliminarDocumentoXProyecto: environment.urlApi + '/externo/api/DocumentoXProyecto/eliminar-DocumentoXProyecto',
        obtenerRegistroPatronal: environment.urlApi + '/externo/api/RH/RegistroPatronal/obtener-RegistroPatronal',
        obtenerPaginadoRegistroPatronal: environment.urlApi + '/externo/api/RH/RegistroPatronal/obtener-paginado-RegistroPatronal',
        agregarRegistroPatronal: environment.urlApi + '/externo/api/RH/RegistroPatronal/agregar-RegistroPatronal',
        actualizarRegistroPatronal: environment.urlApi + '/externo/api/RH/RegistroPatronal/actualizar-RegistroPatronal',
        agregarDocumentoXContratoProyecto: environment.urlApi + '/externo/api/DocumentoXContratoProyecto/agregar-DocumentoXContratoProyecto',
        obtenerDocumentoXContratoProyecto: environment.urlApi + '/externo/api/DocumentoXContratoProyecto/obtener-DocumentoXContratoProyecto',
        obtenerDocumentoXContratoProyectoPaginado: environment.urlApi + '/externo/api/DocumentoXContratoProyecto/obtener-paginado-DocumentoXContratoProyecto',
        eliminarDocumentoXContratoProyecto: environment.urlApi + '/externo/api/DocumentoXContratoProyecto/eliminar-DocumentoXContratoProyecto',
        agregarDocumentoXProducto: environment.urlApi + '/externo/api/DocumentoXProducto/agregar-DocumentoXProducto',
        obtenerDocumentoXProducto: environment.urlApi + '/externo/api/DocumentoXProducto/obtener-DocumentoXProducto',
        obtenerDocumentoXProductoPaginado: environment.urlApi + '/externo/api/DocumentoXProducto/obtener-paginado-DocumentoXProducto',
        eliminarDocumentoXProducto: environment.urlApi + '/externo/api/DocumentoXProducto/eliminar-DocumentoXProducto',

        //Sistemas
        obtenerMenu: environment.urlApi + '/externo/api/menu/obtener-Menu',
        guardarMenuCompleto: environment.urlApi + '/externo/api/menu/guardar-Menu-completo',
        agregarMenu: environment.urlApi + '/externo/api/menu/agregar-Menu',
        obtenerPerfilPaginado: environment.urlApi + '/externo/api/Perfil/obtener-paginado-Perfil',
        actualizarPerfil: environment.urlApi + '/externo/api/Perfil/actualizar-Perfil',
        agregarPerfil: environment.urlApi + '/externo/api/Perfil/agregar-Perfil',
        obtenerMenuUsuario: environment.urlApi + '/externo/api/usuario/obtener-Menu-Usuario',
        obtenerMenuAdministracionSistemas: environment.urlApi + '/externo/api/menu/obtener-Menu-Administracion-Sistemas',
        registrarEmpresaSW: environment.urlApi + '/externo/api/Empresa/registrar-Empresa-SW',
        registrarRenovacionLicenciaEmpresa: environment.urlApi + '/externo/api/RegistroOrdenesCompraEmpresa/registrar-RenovacionLicenciaEmpresa',
        obtenerSubGrupo: environment.urlApi + '/externo/api/SubGrupo/obtener-SubGrupo',
        obtenerFuncionPaginado: environment.urlApi + '/externo/api/CatalogoNomina/FuncionesNomina/obtener-paginado-FuncionesNomina',
        agregarFuncion: environment.urlApi + '/externo/api/CatalogoNomina/FuncionesNomina/agregar-FuncionesNomina',
        actualizarFuncion: environment.urlApi + '/externo/api/CatalogoNomina/FuncionesNomina/actualizar-FuncionesNomina',
        verificarcatalogosempresaAdmin: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-empresaAdmin',
        obtenerConfiguracionGlobal: environment.urlApi + '/externo/api/ConfiguracionGlobal/obtener-ConfiguracionGlobal',
        obtenerConfiguracionGlobalEmpresa: environment.urlApi + '/externo/api/ConfiguracionGlobalEmpresa/obtener-ConfiguracionGlobalEmpresa',
        obtenerTipoVariable: environment.urlApi + '/externo/api/TipoVariable/obtener-TipoVariable',
        agregarTipoVariable: environment.urlApi + '/externo/api/TipoVariable/agregar-TipoVariable',
        actualizarTipoVariable: environment.urlApi + '/externo/api/TipoVariable/actualizar-TipoVariable',
        obtenerProductoCompleto: environment.urlApi + '/externo/api/Producto/obtener-paginado-producto',
        obtenerDocumentoXProductoCompleto: environment.urlApi + '/externo/api/DocumentoXProducto/obtener-paginado-DocumentoXProducto',
        obtenerTasaCambio: environment.urlApi + '/externo/api/tasaCambioCatalogo/obtener-TasaCambio',
        obtenerTasaCambioDOF: environment.urlApi + '/externo/api/tasaCambioCatalogo/obtener-TasaCambioDOF',
        obtenerTasaConversion: environment.urlApi + '/externo/api/tasaConversion/obtener-TasaConversion',
        obtenerTasaCambioRangoInsertar: environment.urlApi + '/externo/api/tasaCambioCatalogo/obtener-TasaCambioRango-Insertar',
        obtenerPais: environment.urlApi + '/externo/api/pais/obtener-Pais',
        revisarLicenciasEmpresa: environment.urlApi + '/externo/api/Empresa/revisar-Licencias-Empresa',
        agregarTimbresEmpresa: environment.urlApi + '/externo/api/RegistroOrdenesCompraEmpresa/agregar-TimbresEmpresa',
        obtenerClavePedimento: environment.urlApi + '/externo/api/ClavePedimento/obtener-ClavePedimento',
        obtenerClaveIncoterm: environment.urlApi + '/externo/api/ClaveIncoterm/obtener-ClaveIncoterm',


        obtenerTareas: environment.urlApi + '/externo/api/Tareas/obtener-Tareas',
        agregarTareas: environment.urlApi + '/externo/api/Tareas/agregar-Tareas',
        actualizarTareas: environment.urlApi + '/externo/api/Tareas/actualizar-Tareas',
        actualizarTareasAdministrador: environment.urlApi + '/externo/api/Tareas/actualizar-Tareas-Administrador',
        obtenerTareasXUsuario: environment.urlApi + '/externo/api/Tareas/obtenerTareasXUsuario',
        obtenerUsuarioAgrupado: environment.urlApi + '/externo/api/usuario/obtener-UsuarioAgrupado',
        obtenerChatsUsuario: environment.urlApi + '/externo/api/usuario/obtener-Chats-Usuario',
        obtenerEstatusTarea: environment.urlApi + '/externo/api/EstatusTarea/obtener-EstatusTarea',
        eliminarTarea: environment.urlApi + '/externo/api/Tareas/eliminar-Tareas',
        agregarActualizarChats: environment.urlApi + '/externo/api/Chats/agregar-actualizar-Chats',
        eliminarChats: environment.urlApi + '/externo/api/Chats/eliminar-Chats',
        obtenerTareasXUsuariosAdmin: environment.urlApi + '/externo/api/Tareas/obtenerTareasXUsuariosAdmin',
        agregarTareaXNota: environment.urlApi + '/externo/api/TareasXNotas/agregar-TareasXNotas',
        agregarTareaXDocumento: environment.urlApi + '/externo/api/TareasXDocumento/agregar-TareasXDocumento',
        eliminarDocumento: environment.urlApi + '/externo/api/TareasXDocumento/eliminar-TareasXDocumento',
        verificarCatalogosPagosCobranza: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-Pagoscobranza',
        verificarCatalogosPagosProveedor: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-Pagosproveedor',
        obtenerInforTransaccionComercialCompleta: environment.urlApi + '/externo/api/TransaccionComercialCompleta/obtenerInforTransaccionComercialCompleta',
        agregarPagoClienteCompleto: environment.urlApi + '/externo/api/pagoClienteCompleto/agregar-PagoClienteCompleta',
        actualizarPagoClienteCompleto: environment.urlApi + '/externo/api/pagoClienteCompleto/actualizar-PagoClienteCompleta',
        agregarPagoProveedorCompleto: environment.urlApi + '/externo/api/pagoProveedorCompleto/agregar-PagoProveedorCompleta',
        actualizarPagoProveedorCompleto: environment.urlApi + '/externo/api/pagoProveedorCompleto/actualizar-PagoProveedorCompleta',
        obtenerCobranzaDistribucionSaldosAbonos: environment.urlApi + '/externo/api/pagoClienteDetalle/obtener-CobranzaDistribucionSaldosAbonos',
        obtenerCuentaXPagarDistribucionSaldosPagos: environment.urlApi + '/externo/api/pagoProveedorDetalle/obtener-CuentaXPagarDistribucionSaldosPagos',
        agregarProducto: environment.urlApi + '/externo/api/Producto/agregar-Producto',
        agregarEmpresaTercero: environment.urlApi + '/externo/api/Tercero/agregar-Tercero',
        verificarCatalogosTerceros: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-terceros',
        verificarCatalogosBancos: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-bancos',
        catalogoObtenerBanco: environment.urlApi + '/externo/api/catalogos/Banco/obtener-Banco',
        obtenerConsecutivoBanco: environment.urlApi + '/externo/api/ConsecutivoCodigoBanco/obtener-ConsecutivoCodigoBanco',
        actualizarBancos: environment.urlApi + '/externo/api/bancos/actualizar-Bancos',
        agregarBancos: environment.urlApi + '/externo/api/bancos/agregar-Bancos',
        agregarVendedor: environment.urlApi + '/externo/api/vendedor/agregar-Vendedor',
        agregarComprador: environment.urlApi + '/externo/api/Comprador/agregar-Comprador',
        obtenerPaginadoPagoClienteSustitucion: environment.urlApi + '/externo/api/PagoCliente/obtener-Paginado-PagoCliente-Sustitucion',
        verificarCatalogosConfiguracionGlobal: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-configuracionGlobal',
        agregarConfiguracionGlobal: environment.urlApi + '/externo/api/ConfiguracionGlobal/agregar-ConfiguracionGlobal',
        actualizarConfiguracionGlobal: environment.urlApi + '/externo/api/ConfiguracionGlobal/actualizar-ConfiguracionGlobal',
        actualizarConfiguracionGlobalJSON: environment.urlApi + '/externo/api/ConfiguracionGlobal/actualizar-ConfiguracionGlobal-Json',
        actualizarConfiguracionGlobalEmpresa: environment.urlApi + '/externo/api/ConfiguracionGlobalEmpresa/actualizar-ConfiguracionGlobalEmpresa',

        verificarCatalogosMovimientosBancarios: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-movimientos-bancarios',
        agregarListaMovimientosBancos: environment.urlApi + '/externo/api/MovimientoBancos/agregar-ListaMovimientoBancos',
        obtenerMovimientosBancariosXFechas: environment.urlApi + '/externo/api/MovimientoBancos/obtener-MovimientosBancariosXFechas',
        verificarCatalogosSaldoBancos: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-saldos-bancos',

        verificarCatalogosBusquedaDocumentosVentas: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-busqueda-documentosventas',
        obtenerTransaccionComercial: environment.urlApi + '/externo/api/TransaccionComercial/obtener-TransaccionComercial',        
        obtenerTransaccionComercialV2: environment.urlApi + '/externo/api/TransaccionComercial/obtener-TransaccionComercialV2',
        obtenerTransaccionComercialDetalle: environment.urlApi + '/externo/api/TransaccionComercialDetalle/obtener-TransaccionComercialDetalle',
        reenviarFactura: environment.urlApi + '/externo/api/TransaccionComercialCompleta/reenviarFactura',
        obtenerAñoMesTransaccionComercial: environment.urlApi + '/externo/api/TransaccionComercial/obtener-AñoMesTransaccionComercial',
        revisarFactura: environment.urlApi + '/externo/api/TransaccionComercialCompleta/revisarFactura',
        revisarSaldosInventario: environment.urlApi + '/externo/api/SaldoAlmacen/revisar-SaldoInventario',
        revisarSaldosInventarioBodega: environment.urlApi + '/externo/api/SaldoAlmacen/revisar-SaldoInventarioBodega',
        revisarProductosAntesDeDuplicarTransaccionComercialCompleta: environment.urlApi +
            '/externo/api/TransaccionComercialCompleta/revisarProductosAntesDeDuplicar-TransaccionComercialCompleta',
        duplicarTransaccionComercialCompleta: environment.urlApi +
            '/externo/api/TransaccionComercialCompleta/duplicar-TransaccionComercialCompleta',
        obtenerInfoTimbradoFEMexico: environment.urlApi + '/externo/api/Timbrado_FEMexico/obtener-InfoTimbrado_FEMexico',
        obtenerInfoTimbradoFEMexicoPagoCliente: environment.urlApi + '/externo/api/Timbrado_FEMexico/obtener-InfoTimbrado_FEMexico_PagoCliente',
        leerXMLVincularDocumentoVentas: environment.urlApi + '/externo/api/GeneralesTransaccionComercialController/leer-XMLVincularDocumentoVentas',
        leerXMLVincularPagoCliente: environment.urlApi + '/externo/api/pagoClienteCompleto/leer-XMLVincularPagoCliente',
        obtenerListaUUIDRelacionados: environment.urlApi + '/externo/api/TransaccionComercial/obtener-ListaUUIDRelacionado',
        actualizarTransaccionComercial: environment.urlApi +
            '/externo/api/TransaccionComercial/actualizar-TransaccionComercial',
        vincularFacturaVentaXML: environment.urlApi + '/externo/api/GeneralesTransaccionComercialController/vincular-facturaventaxml',
        vincularPagoClienteXML: environment.urlApi + '/externo/api/pagoClienteCompleto/vincular-PagoClienteXML',
        cancelarTransaccionComercial: environment.urlApi + '/externo/api/TransaccionComercial/cancelar-TransaccionComercial',
        generarContabilidadVentasMX: environment.urlApi + '/externo/api/Contabilidad/generarContabilidadVentasMX',
        obtenerTimbradoFEMexico: environment.urlApi + '/externo/api/Timbrado_FEMexico/obtener-Timbrado_FEMexico',
        reporteTransaccionComercialPaginado: environment.urlApi + '/externo/api/TransaccionComercial/ReporteTransaccionComercialPaginado',
        obtenerCobranzaGeneral: environment.urlApi + '/externo/api/cobranzaGeneral/obtener-CobranzaGeneral',
        obtenerCobranzaResumenDeudaPorCliente: environment.urlApi + '/externo/api/cobranzaGeneral/obtener-CobranzaResumenDeudaPorCliente',
        obtenerDetalleCobranzasPorTransaccionComercial: environment.urlApi + '/externo/api/pagoClienteDetalle/obtener-DetalleCobranzasPorTransaccionComercial',
        obtenerTransaccionComercialDesdeDetalleOrig: environment.urlApi + '/externo/api/TransaccionComercial/obtener-TransaccionComercial-DesdeDetalleOrig',
        convertirpedidoAOrdenCompra: environment.urlApi +
            '/externo/api/TransaccionComercialCompleta/convertir-pedidoAOrdenCompra',
        obtenerTransaccionComercialDocumentosNoRelacionados: environment.urlApi + '/externo/api/TransaccionComercial/obtener-TransaccionComercial-DocumentosNoRelacionados',
        verificarCatalogosDocumentosVentas: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-documentosventas',
        InfoProductoBodega: environment.urlApi + '/externo/api/SaldoAlmacen/InfoProductoBodega',
        InfoSaldosInventarios: environment.urlApi + '/externo/api/SaldoAlmacen/InfoSaldosInventarios',
        agregarTransaccionComercialCompleta: environment.urlApi +
            '/externo/api/TransaccionComercialCompleta/agregar-TransaccionComercialCompleta',
        registrarEntradaTransaccionComercialCompleta: environment.urlApi +
            '/externo/api/TransaccionComercialCompleta/registrar-EntradaTransaccionComercialCompleta',
        revisarSaldoProductoEmpresa: environment.urlApi + '/externo/api/SaldoAlmacen/revisar-SaldoProductoEmpresa',
        revisarSaldoProductoLote: environment.urlApi + '/externo/api/SaldoAlmacen/revisar-SaldoProductoLote',
        obtenerLotesXProducto: environment.urlApi + '/externo/api/LotesProducto/obtener-LotesXProducto',
        obtenerTodosLotesEmpresaXProducto: environment.urlApi + '/externo/api/LotesProducto/obtener-TodosLotesEmpresaXProducto',
        obtenerTransaccionComercialDocumentosNoRelacionadosPaginado: environment.urlApi + '/externo/api/TransaccionComercial/obtener-paginado-TransaccionComercial-DocumentosNoRelacionados',
        obtenerTransaccionComercialVentasDocumentosARelacionarPaginado: environment.urlApi + '/externo/api/TransaccionComercial/obtener-paginado-TransaccionComercial-DocumentosARelacionar',
        verificarCatalogosDocumentosVentasModificar: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-documentosventas-Modificar',
        obtenerRelacionesSAT: environment.urlApi + '/externo/api/RelacionesSAT/obtener-RelacionesSAT',
        actualizarTransaccionComercialCompleta: environment.urlApi +
            '/externo/api/TransaccionComercialCompleta/actualizar-TransaccionComercialCompleta',
        obtenerTransaccionComercialUnionDocumentosRelacionados: environment.urlApi + '/externo/api/TransaccionComercial/obtener-TransaccionComercial-UnionDocumentosRelacionados',
        obtenerTransaccionComercialUnionDocumentosRelacionadosPaginado: environment.urlApi + '/externo/api/TransaccionComercial/obtener-paginado-TransaccionComercial-UnionDocumentosRelacionados',
        obtenerTransaccionComercialAsociarOrdenCompra: environment.urlApi + '/externo/api/TransaccionComercial/obtener-TransaccionComercial-AsociarOrdenCompra',

        obtenerListaSATMotivo: environment.urlApi + '/externo/api/MtSATMotivoCancela/obtener-MtSATMotivoCancela',
        verificarCatalogosCobranza: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-cobranza',
        obtenerPagoClienteComplemento: environment.urlApi + '/externo/api/pagoCliente/obtener-PagoCliente-Complemento',
        obtenerTimbradoCobranza: environment.urlApi + '/externo/api/Timbrado_Cobranza/obtener-Timbrado_Cobranza',
        sustituirCancelacionPagoCliente: environment.urlApi + '/externo/api/PagoCliente/sustituir-cancelacion-PagoCliente',
        obtenerListaUUIDPagoClienteRelacionado: environment.urlApi + '/externo/api/PagoCliente/obtener-ListaUUIDPagoClienteRelacionado',
        actualizarPagoCliente: environment.urlApi + '/externo/api/pagoCliente/actualizar-PagoCliente',
        revisarComprobantePago: environment.urlApi + '/externo/api/pagoClienteCompleto/revisar-ComplementoPago',
        reenviarComplementoPago: environment.urlApi + '/externo/api/pagoClienteCompleto/reenviar-ComplementoPago',
        cancelarPagoCliente: environment.urlApi + '/externo/api/PagoCliente/cancelar-PagoCliente',

        // Inventarios
        verificarCatalogosBusquedaDocumentosInventario: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-busqueda-documentosinventario',
        obtenerListaTerceros: environment.urlApi + '/externo/api/TransaccionComercial/obtener-ListaTerceros',
        verificarCatalogosMovimientosAlmacen: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-movimientosAlmacen',
        obtenerBodegaXSaldoAlmacen: environment.urlApi + '/externo/api/bodega/obtener-BodegaXSaldoAlmacen',
        revisarLotesXProducto: environment.urlApi + '/externo/api/LotesProducto/revisar-LotesXProducto',
        agregarLotesYProducto: environment.urlApi + '/externo/api/LotesProducto/agregar-LotesYProducto',
        verificarCatalogosSaldoInventarios: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-saldo-inventario',
        obtenerAnoMesSaldoAlmacen: environment.urlApi + '/externo/api/SaldoAlmacen/obtener-AnoMesSaldoAlmacen',
        eliminarTransaccionComercialCompleta: environment.urlApi +
            '/externo/api/TransaccionComercialCompleta/eliminar-TransaccionComercialCompleta',
        obtenerProductoConSaldoYMovimientos: environment.urlApi + '/externo/api/SaldoAlmacen/obtener-ProductoConSaldoYMovimientos',
        obtenerProductoDeBodegaConSaldo: environment.urlApi + '/externo/api/SaldoAlmacen/obtener-ProductoDeBodegaConSaldo',
        verificarCatalogosEntradasTraslados: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-entradas-traslados',


        dashboardVentasCompleto: environment.urlApi + '/externo/api/dashboards/obtener-DashboardVentasCompleto',
        dashboardVentasMensuales: environment.urlApi + '/externo/api/dashboards/obtener-DashboardVentasMensuales',
        obtenerDatosDashboardVentas: environment.urlApi + '/externo/api/dashboards/obtener-DatosDashboardVentas',

        ///Compras

        verificarCatalogosBusquedaDocumentosCompras: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-busqueda-documentoscompras',
        revisarFacturaCompra: environment.urlApi + '/externo/api/TransaccionComercialCompleta/revisarDocumentoFacturaCompra',
        revisarDocumentoCompraNoFacturaCompra: environment.urlApi + '/externo/api/TransaccionComercialCompleta/revisarDocumentoCompraNoFacturaCompra',
        obtenerCuentasPagarGeneral: environment.urlApi + '/externo/api/cuentasPagarGeneral/obtener-CuentasPagarGeneral',
        duplicarTransaccionComercialComprasCompleta: environment.urlApi +
            '/externo/api/TransaccionComercialCompleta/duplicar-TransaccionComercialComprasCompleta',
        obtenerDetalleCXPPorTransaccionComercial: environment.urlApi + '/externo/api/PagoProveedorDetalle/obtener-DetalleCXPPorTransaccionComercial',
        obtenerCARGARXML: environment.urlApi + '/externo/api/CARGARXML/obtener-CARGARXML',
        actualizarCargarXML: environment.urlApi + '/externo/api/CARGARXML/actualizar-CARGARXML',
        verificarCatalogosComprasEgresos: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-comprasegresos',
        revisarNumeroDocumentoProveedor: environment.urlApi + '/externo/api/TransaccionComercial/obtener-TransaccionComercial',
        obtenerTransaccionComercialComprasDocumentosARelacionarPaginado: environment.urlApi + '/externo/api/TransaccionComercial/obtener-paginado-TransaccionComercial-DocumentosARelacionar',
        obtenerCiudadEmpresa: environment.urlApi + '/externo/api/Ciudad/obtener-Ciudad',
        cargarDocumentoXML: environment.urlApi + '/externo/api/GeneralesTransaccionComercialController/cargar-documentoxml',
        obtenerCARGARXMLCompleto: environment.urlApi + '/externo/api/CARGARXML/obtener-CARGARXML-Completo',

        //Pago proveedor
        verificarCatalogosCuentasPagar: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-cuentas-pagar',
        obtenerPagoProveedorComplemento: environment.urlApi + '/externo/api/pagoProveedor/obtener-PagoProveedor-Complemento',
        cancelarPagoProveedor: environment.urlApi + '/externo/api/pagoProveedorCompleto/cancelar-PagoProveedor',
        obtenerPagoProveedorDetalle: environment.urlApi + '/externo/api/pagoProveedorDetalle/obtener-PagoProveedorDetalle',
        verificarCatalogosCargarXML: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-cargarXML',
        revisarDocumentoProveedor: environment.urlApi + '/externo/api/CARGARXML/revisar-DocumentoProveedor',
        agregarDocumentosProveedor: environment.urlApi + '/externo/api/CARGARXML/agregar-DocumentosProveedor',

        //Contabilidad
        verificarCatalogosComprobantesPolizas: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-comprobantes-polizas',
        obtenerMovimientosContablesAgrupado: environment.urlApi + '/externo/api/movimientoContable/obtener-MovimientoContable-Agrupado',
        obtenerDetalleSaldoContable: environment.urlApi + '/externo/api/movimientoContable/obtener-DetalleSaldoContable',
        revisarPolizaContable: environment.urlApi + '/externo/api/movimientoContable/revisarPolizaContable',

        //Sistemas
        obtenerbalanceTimbres: environment.urlApi + '/externo/api/RegistroOrdenesCompraEmpresa/obtener-balanceTimbres',
        actualizarContrasenaUsuario: environment.urlApi + '/externo/api/usuario/actualizar-contrasena-usuario',
        guardarAvatar: environment.urlApi + '/externo/api/usuario/actualizar-Avatar-Usuario',
        guardarImagen: environment.urlApi + '/externo/api/empresaconfiguracionImagenes/agregar-EmpresaConfiguracionImagenes',
        eliminarImagen: environment.urlApi + '/externo/api/empresaconfiguracionImagenes/eliminar-EmpresaConfiguracionImagenes',

        //Copomex
        //obtenerColoniasXCPCopomex: environment.urlServicioDireccionCopomex + '/get_colonia_por_cp/',
        //obtenerInfoXCP: environment.urlServicioDireccionCopomex + '/info_cp/',

        //Comercio Exterior
        obtenerColoniasPorCodigoPostal: environment.urlApi + '/externo/api/comercioExterior/obtener-ColoniasPorCodigoPostal',
        obtenerInfoCodigoPostal: environment.urlApi + '/externo/api/comercioExterior/obtener-InfoCodigoPostal',
        obtenerEstados: environment.urlApi + '/externo/api/comercioExterior/obtener-Estados',
        obtenerMunicipios: environment.urlApi + '/externo/api/comercioExterior/obtener-Municipios',
        obtenerLocalidades: environment.urlApi + '/externo/api/comercioExterior/obtener-Localidades',
        obtenerCatalogoComercioExterior: environment.urlApi + '/externo/api/catalogos/verificar-catalogos-comercio-exterior',


    }

    constructor(protected http: HttpClient, private config: ConfigService, private authService: AuthService) {
        super(http);
    }

    obtenerProyecto(proyecto: Proyecto) {

        return this.post<JsonResponse>(this.urls.obtenerProyecto, proyecto, this.authService.token);
    }

    obtenerPaginadoProyecto(tamanioPagina: number, pagina: number, IdEmpresa: string, Activo: boolean) {

        let urlFinal = this.urls.obtenerPaginadoProyecto + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`

        if (IdEmpresa != null)
            urlFinal += `&IdEmpresa=${IdEmpresa}`


        if (Activo != null)
            urlFinal += `&Activo=${Activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarProyectos(proyecto: Proyecto) {

        return this.post<JsonResponse>(this.urls.agregarProyecto, proyecto, this.authService.token);
    }

    actualizarProyectos(proyecto: Proyecto) {
        return this.post<JsonResponse>(this.urls.actualizarProyecto, proyecto, this.authService.token);
    }

    obtenerContrato(contratoProyecto: ContratoProyecto) {

        return this.post<JsonResponse>(this.urls.obtenerContrato, contratoProyecto, this.authService.token);
    }

    obtenerPaginadoContrato(tamanioPagina: number, pagina: number, IdProyecto: string, Activo: boolean) {

        let urlFinal = this.urls.obtenerPaginadoContrato + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`

        if (IdProyecto != null)
            urlFinal += `&IdProyecto=${IdProyecto}`


        if (Activo != null)
            urlFinal += `&Activo=${Activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarContrato(contratoProyecto: ContratoProyecto) {

        return this.post<JsonResponse>(this.urls.agregarContrato, contratoProyecto, this.authService.token);
    }

    actualizarContrato(contratoProyecto: ContratoProyecto) {
        return this.post<JsonResponse>(this.urls.actualizarContrato, contratoProyecto, this.authService.token);
    }

    obtenerRegistroPatronal(registroPatronal: RegistroPatronal) {

        return this.post<JsonResponse>(this.urls.obtenerRegistroPatronal, registroPatronal, this.authService.token);
    }

    obtenerPaginadoRegistroPatronal(tamanioPagina: number, pagina: number, IdEmpresa: string, Activo: boolean) {

        let urlFinal = this.urls.obtenerPaginadoRegistroPatronal + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`

        if (IdEmpresa != null)
            urlFinal += `&IdEmpresa=${IdEmpresa}`


        if (Activo != null)
            urlFinal += `&Activo=${Activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarRegistroPatronal(registroPatronal: RegistroPatronal) {

        return this.post<JsonResponse>(this.urls.agregarRegistroPatronal, registroPatronal, this.authService.token);
    }

    actualizarRegistroPatronal(registroPatronal: RegistroPatronal) {
        return this.post<JsonResponse>(this.urls.actualizarRegistroPatronal, registroPatronal, this.authService.token);
    }

    obtenerPaginadoHistorialUsoTimbres(tamanioPagina: number, pagina: number, IdEmpresa: any) {

        let urlFinal = this.urls.obtenerPaginadoHistorialUsoTimbres + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (IdEmpresa != null)
            urlFinal += `&IdEmpresa=${IdEmpresa}`

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerHistorialUsoTimbres(historialUsoTimbres: HistorialUsoTimbres) {

        return this.post<JsonResponse>(this.urls.obtenerHistorialUsoTimbres, historialUsoTimbres, this.authService.token);
    }

    obtenerColoniasXCP(cp: string) {

        return this.get<JsonResponse>(this.urls.obtenerDomicilio + `?CP=${cp}`, this.authService.token);
    }

    obtenerComprador(vendedor?: Comprador) {
        return this.post<JsonResponse>(this.urls.obtenerComprador, vendedor, this.authService.token);
    }

    obtenerCompradorPaginado(tamanioPagina: number, pagina: number, idEmpresa: string) {

        let urlFinal = this.urls.obtenerCompradorPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (idEmpresa != null)
            urlFinal += `&IdEmpresa=${idEmpresa}`

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    actualizarComprador(comprador: Comprador) {

        return this.post<JsonResponse>(this.urls.actualizarComprador, comprador, this.authService.token);
    }

    actualizarVendedor(vendedor: Vendedor) {

        return this.post<JsonResponse>(this.urls.actualizarVendedor, vendedor, this.authService.token);
    }

    obtenerCorreoCRM(correoCRM?: CorreoCRM) {
        return this.post<JsonResponse>(this.urls.obtenerCorreoCRM, correoCRM, this.authService.token);
    }

    obtenerVendedorXCliente(IdTercero?: any, IdVendedor?: any) {

        let urlFinal = this.urls.obtenerVendedorXCliente;

        if (IdTercero != undefined && IdTercero != null) {
            urlFinal += `&IdTercero=${IdTercero}`;
        }

        if (IdVendedor != undefined && IdVendedor != null) {
            urlFinal += `&IdVendedor=${IdVendedor}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerVendedor(vendedor?: Vendedor) {
        return this.post<JsonResponse>(this.urls.obtenerVendedor, vendedor, this.authService.token);
    }

    obtenerVendedorPaginado(tamanioPagina: number, pagina: number, nombre: string, idEmpresa: string, activo?: boolean) {

        let urlFinal = this.urls.obtenerVendedorPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (nombre != undefined && nombre != null && nombre != '') {
            urlFinal += `&nombre=${nombre}`;
        }

        if (activo != undefined && activo != null) {
            urlFinal += `&activo=${activo}`;
        }

        if (idEmpresa != null)
            urlFinal += `&idEmpresa=${idEmpresa}`


        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    actualizarProductoCuentaContable(producto: Producto) {

        return this.post<JsonResponse>(this.urls.actualizarProductoCuentaContable, producto, this.authService.token);
    }

    actualizarProducto(producto: Producto) {

        return this.post<JsonResponse>(this.urls.actualizarProducto, producto, this.authService.token);
    }

    obtenerTercero(tercero: Tercero) {
        return this.post<JsonResponse>(this.urls.obtenerTercero, tercero, this.authService.token);
    }

    revisarTercero(tercero: Tercero) {
        return this.post<JsonResponse>(this.urls.revisarTercero, tercero, this.authService.token);
    }

    obtenerDireccionTercero(filtros: { IdTercero: any }) {
        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerDireccionTercero}?${queryString}`
            : this.urls.obtenerDireccionTercero;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTerceroPaginado(tamanioPagina: number, pagina: number, nombre?: string, identificador?: string, idEmpresa?: string, esCliente?: boolean, esProveedor?: boolean) {

        let urlFinal = this.urls.obtenerTerceroPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (nombre != undefined && nombre != null && nombre != '') {
            urlFinal += `&nombre=${nombre}`;
        }

        if (identificador != undefined && identificador != null && identificador != '') {
            urlFinal += `&identificador=${identificador}`;
        }

        if (esCliente != undefined && esCliente != null) {
            urlFinal += `&esCliente=${esCliente}`;
        }

        if (esProveedor != undefined && esProveedor != null) {
            urlFinal += `&esProveedor=${esProveedor}`;
        }

        if (idEmpresa != undefined && idEmpresa != null)
            urlFinal += `&idEmpresa=${idEmpresa}`


        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTerceroPaginadoDocumentoVenta(tamanioPagina: number, pagina: number, nombre: string, identificador: string, idEmpresa: string, esCliente?: boolean, esProveedor?: boolean, obtenerDefecto?: boolean) {

        let urlFinal = this.urls.obtenerTerceroPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (nombre != undefined && nombre != null && nombre != '') {
            urlFinal += `&nombre=${nombre}`;
        }


        if (identificador != undefined && identificador != null && identificador != '') {
            urlFinal += `&identificador=${identificador}`;
        }

        if (esCliente != undefined && esCliente != null) {
            urlFinal += `&esCliente=${esCliente}`;
        }

        if (esProveedor != undefined && esProveedor != null) {
            urlFinal += `&esProveedor=${esProveedor}`;
        }

        if (obtenerDefecto != undefined && obtenerDefecto != null) {
            urlFinal += `&obtenerDefecto=${obtenerDefecto}`;
        }

        urlFinal += `&idEmpresa=${idEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    actualizarTercero(tercero: Tercero) {

        return this.post<JsonResponse>(this.urls.actualizarTercero, tercero, this.authService.token);
    }

    actualizarTerceroCuentaContable(tercero: Tercero) {

        return this.post<JsonResponse>(this.urls.actualizarTerceroCuentaContable, tercero, this.authService.token);
    }

    verificarCatalogosInformacionEmpresa(IdEmpresa: any) {

        //console.log('verificarCatalogosInformacionEmpresa');

        const urlFinal = this.urls.verificarCatalogosInformacionEmpresa + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerEmpresaInformacionLicencia(IdEmpresa: any) {

        const urlFinal = this.urls.obtenerEmpresaInformacionLicencia + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    verificarCatalogosProductos(IdEmpresa: any) {

        //console.log('verificarCatologosProductos');

        const urlFinal = this.urls.verificarCatalogosProducto + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerProducto(producto: Producto) {
        return this.post<JsonResponse>(this.urls.obtenerProducto, producto, this.authService.token);
    }

    obtenerCatalogoProductoListaPrecioAgregar(IdEmpresa: any, Activo?: boolean) {

        let urlFinal = this.urls.obtenerCatalogoProductoListaPrecioAgregar + `?idEmpresa=${IdEmpresa}`;

        if (Activo != undefined && Activo != null) {
            urlFinal += `&Activo=${Activo}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerCatalogoProductoListaPrecio(IdEmpresa: any, Activo?: boolean, IdListaPrecio?: any) {

        let urlFinal = this.urls.obtenerCatalogoProductoListaPrecio + `?idEmpresa=${IdEmpresa}`;

        if (Activo != undefined && Activo != null) {
            urlFinal += `&Activo=${Activo}`;
        }

        if (IdListaPrecio != undefined && IdListaPrecio != null) {
            urlFinal += `&IdListaPrecio=${IdListaPrecio}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerProductoPaginado(tamanioPagina: number, pagina: number, nombre: string, idEmpresa: string, activo?: boolean) {

        let urlFinal = this.urls.obtenerProductoPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (nombre != undefined && nombre != null && nombre != '') {
            urlFinal += `&nombre=${nombre}`;
        }

        if (activo != undefined && activo != null) {
            urlFinal += `&activo=${activo}`;
        }

        if (idEmpresa != null)
            urlFinal += `&idEmpresa=${idEmpresa}`

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    verificarCatalogosTipoMovimiento(tipoMovimiento: TipoMovimiento) {
        return this.post<JsonResponse>(this.urls.verificarCatalogosTipoMovimiento, tipoMovimiento, this.authService.token);
    }

    verificarCatalogosConsecutivo(consecutivo: Consecutivo) {
        return this.post<JsonResponse>(this.urls.verificarCatalogosConsecutivo, consecutivo, this.authService.token);
    }

    verificarimpuestoscatalogosempresa(IdEmpresa: any) {
        let urlFinal = this.urls.verificarimpuestoscatalogosempresa + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerCertificadosCSDEmpresa(certificadosCSDEmpresa: CertificadosCSDEmpresa) {

        return this.post<JsonResponse>(this.urls.obtenerCertificadosCSDEmpresa, certificadosCSDEmpresa, this.authService.token);
    }

    cargoConRedireccionamientoRenovacionLicenciaXEmpresa(registroOrdenesCompraEmpresa: RegistroOrdenesCompraEmpresa) {
        return this.post<JsonResponse>(this.urls.cargoConRedireccionamientoRenovacionLicenciaXEmpresa, registroOrdenesCompraEmpresa, this.authService.token);
    }

    cargoConRedireccionamientoCompraTimbres(registroOrdenesCompraEmpresa: RegistroOrdenesCompraEmpresa) {
        return this.post<JsonResponse>(this.urls.cargoConRedireccionamientoCompraTimbres, registroOrdenesCompraEmpresa, this.authService.token);
    }

    agregarCertificadosCSDEmpresa(certificadosCSDEmpresa: CertificadosCSDEmpresa) {
        return this.post<JsonResponse>(this.urls.agregarCertificadosCSDEmpresa, certificadosCSDEmpresa, this.authService.token);
    }

    actualizarCertificadosCSDEmpresa(certificadosCSDEmpresa: CertificadosCSDEmpresa) {
        return this.post<JsonResponse>(this.urls.actualizarCertificadosCSDEmpresa, certificadosCSDEmpresa, this.authService.token);
    }

    agregarImagenesEmpresa(imagenesEmpresa: ImagenesEmpresa) {
        return this.post<JsonResponse>(this.urls.agregarImagenesEmpresa, imagenesEmpresa, this.authService.token);
    }

    actualizarImagenesEmpresa(imagenesEmpresa: ImagenesEmpresa) {
        return this.post<JsonResponse>(this.urls.actualizarImagenesEmpresa, imagenesEmpresa, this.authService.token);
    }

    actualizarEmpresa(empresa: Empresa) {
        return this.post<JsonResponse>(this.urls.actualizarEmpresa, empresa, this.authService.token);
    }

    actualizarEmpresaNombre(empresa: Empresa) {
        return this.post<JsonResponse>(this.urls.actualizarEmpresaNombre, empresa, this.authService.token);
    }

    obtenerSubGrupoEmpresa(SubGrupoEmpresa: SubGrupoEmpresa) {
        return this.post<JsonResponse>(this.urls.obtenerSubGrupoEmpresa, SubGrupoEmpresa, this.authService.token);
    }

    agregarSubGrupoEmpresa(SubGrupoEmpresa: SubGrupoEmpresa) {
        return this.post<JsonResponse>(this.urls.agregarSubGrupoEmpresa, SubGrupoEmpresa, this.authService.token);
    }

    actualizarSubGrupoEmpresa(SubGrupoEmpresa: SubGrupoEmpresa) {
        return this.post<JsonResponse>(this.urls.actualizarSubGrupoEmpresa, SubGrupoEmpresa, this.authService.token);
    }

    agregarContabilizarModulos(contabilizarModulos: ContabilizarModulos) {
        return this.post<JsonResponse>(this.urls.agregarContabilizarModulos, contabilizarModulos, this.authService.token);
    }

    obtenerCargo(cargo: Cargo) {
        return this.post<JsonResponse>(this.urls.obtenerCargo, cargo, this.authService.token);
    }

    obtenerCargoPaginado(tamanioPagina: number, pagina: number, IdEmpresa: any, Activo?: boolean) {

        let urlFinal = this.urls.obtenerCargoPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        urlFinal += `&idEmpresa=${IdEmpresa}`;

        if (Activo != undefined && Activo != null) {
            urlFinal += `&Activo=${Activo}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarCargo(cargo: Cargo) {
        return this.post<JsonResponse>(this.urls.agregarCargo, cargo, this.authService.token);
    }

    actualizarCargo(cargo: Cargo) {
        return this.post<JsonResponse>(this.urls.actualizarCargo, cargo, this.authService.token);
    }

    obtenerAreaGeografica(areaGeografica: AreaGeografica) {
        return this.post<JsonResponse>(this.urls.obtenerAreaGeografica, areaGeografica, this.authService.token);
    }

    agregarAreaGeografica(areaGeografica: AreaGeografica) {
        return this.post<JsonResponse>(this.urls.agregarAreaGeografica, areaGeografica, this.authService.token);
    }

    actualizarAreaGeografica(areaGeografica: AreaGeografica) {
        return this.post<JsonResponse>(this.urls.actualizarAreaGeografica, areaGeografica, this.authService.token);
    }

    obtenerAreaLaboral(areaLaboral: AreaLaboral) {
        return this.post<JsonResponse>(this.urls.obtenerAreaLaboral, areaLaboral, this.authService.token);
    }

    obtenerAreaLaboralPaginado(tamanioPagina: number, pagina: number, idEmpresa: string, activo: boolean) {

        let urlFinal = this.urls.obtenerAreaLaboralPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&idEmpresa=${idEmpresa}`;

        if (activo != null)
            urlFinal += `&activo=${activo}`

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarAreaLaboral(areaLaboral: AreaLaboral) {
        return this.post<JsonResponse>(this.urls.agregarAreaLaboral, areaLaboral, this.authService.token);
    }

    actualizarAreaLaboral(areaLaboral: AreaLaboral) {
        return this.post<JsonResponse>(this.urls.actualizarAreaLaboral, areaLaboral, this.authService.token);
    }

    obtenerMedioElectronico(medioElectronico: MedioElectronico) {
        return this.post<JsonResponse>(this.urls.obtenerMedioElectronico, medioElectronico, this.authService.token);
    }

    obtenerPerfilEmpresaPaginado(tamanioPagina: number, pagina: number, idEmpresa: string, activo: boolean) {

        let urlFinal = this.urls.obtenerPerfilEmpresaPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&idEmpresa=${idEmpresa}`;

        if (activo != null)
            urlFinal += `&activo=${activo}`

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    actualizarPerfilEmpresa(perfilEmpresa: PerfilEmpresa) {

        return this.post<JsonResponse>(this.urls.actualizarPerfilEmpresa, perfilEmpresa, this.authService.token);
    }

    agregarperfilEmpresaDetallePerfil(perfilEmpresa: PerfilEmpresa) {

        return this.post<JsonResponse>(this.urls.agregarperfilEmpresaDetallePerfil, perfilEmpresa, this.authService.token);
    }

    obtenerDetallePerfil(detallePerfil: DetallePerfil) {

        return this.post<JsonResponse>(this.urls.obtenerDetallePerfil, detallePerfil, this.authService.token);
    }

    obtenerUsuarioPaginado(tamanioPagina: number, pagina: number, idEmpresa: string, idUsuarioConectado, activo: boolean) {

        let urlFinal = this.urls.obtenerUsuarioPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&idEmpresa=${idEmpresa}`;

        if (idUsuarioConectado != null) {
            urlFinal += `&idUsuarioConectado=${idUsuarioConectado}`;
        }

        if (activo != null) {
            urlFinal += `&activo=${activo}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerUsuario(usuario: Usuario) {

        return this.post<JsonResponse>(this.urls.obtenerUsuario, usuario, this.authService.token);
    }

    agregarUsuario(usuario: Usuario) {

        return this.post<JsonResponse>(this.urls.agregarUsuario, usuario, this.authService.token);
    }

    actualizarUsuario(usuario: Usuario) {

        return this.post<JsonResponse>(this.urls.actualizarUsuario, usuario, this.authService.token);
    }

    obtenerPerfilPerfilEmpresa(esAdministrador: boolean, esSistema: boolean, IdEmpresa: string, Activo: boolean) {

        let urlFinal = this.urls.obtenerPerfilPerfilEmpresa + `?esAdministrador=${esAdministrador}&esSistema=${esSistema}&IdEmpresa=${IdEmpresa}`;

        if (Activo != null) {
            urlFinal += `&activo=${Activo}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerPerfilEmpresa(perfilEmpresa: PerfilEmpresa) {

        return this.post<JsonResponse>(this.urls.obtenerPerfilEmpresa, perfilEmpresa, this.authService.token);
    }

    obtenerImpuestosSinRegistrar(impuesto: Impuesto) {

        return this.post<JsonResponse>(this.urls.obtenerImpuestosSinRegistrar, impuesto, this.authService.token);
    }

    obtenerImpuesto(impuesto: Impuesto) {

        return this.post<JsonResponse>(this.urls.obtenerImpuesto, impuesto, this.authService.token);
    }

    obtenerImpuestosxEmpresa(impuestosxEmpresa: ImpuestosxEmpresa) {

        return this.post<JsonResponse>(this.urls.obtenerImpuestosxEmpresa, impuestosxEmpresa, this.authService.token);
    }

    obtenerImpuestosxEmpresaPaginado(tamanioPagina: number, pagina: number, IdEmpresa: string, activo: boolean) {

        let urlFinal = this.urls.obtenerImpuestosxEmpresaPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&IdEmpresa=${IdEmpresa}&activo=${activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarImpuestosxEmpresa(impuestosxEmpresa: ImpuestosxEmpresa) {

        return this.post<JsonResponse>(this.urls.agregarImpuestosxEmpresa, impuestosxEmpresa, this.authService.token);
    }

    actualizarImpuestosxEmpresa(impuestosxEmpresa: ImpuestosxEmpresa) {
        return this.post<JsonResponse>(this.urls.actualizarImpuestosxEmpresa, impuestosxEmpresa, this.authService.token);
    }

    obtenerCentroCostos(centroCosto: CentroCosto) {

        return this.post<JsonResponse>(this.urls.obtenerCentroCostos, centroCosto, this.authService.token);
    }

    obtenerCentroCostosPaginado(tamanioPagina: number, pagina: number, IdEmpresa: string, activo: boolean) {

        let urlFinal = this.urls.obtenerCentroCostosPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&IdEmpresa=${IdEmpresa}&activo=${activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarCentroCostos(centroCosto: CentroCosto) {

        return this.post<JsonResponse>(this.urls.agregarCentroCostos, centroCosto, this.authService.token);
    }

    actualizarCentroCostos(centroCosto: CentroCosto) {
        return this.post<JsonResponse>(this.urls.actualizarCentroCostos, centroCosto, this.authService.token);
    }

    obtenerLotes(lotes: Lotes) {

        return this.post<JsonResponse>(this.urls.obtenerLotes, lotes, this.authService.token);
    }

    obtenerPaginadoLotes(tamanioPagina: number, pagina: number, IdEmpresa: string, activo: boolean) {

        let urlFinal = this.urls.obtenerPaginadoLotes + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&IdEmpresa=${IdEmpresa}&activo=${activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarLotes(lotes: Lotes) {

        return this.post<JsonResponse>(this.urls.agregarLotes, lotes, this.authService.token);
    }

    actualizarLotes(lotes: Lotes) {
        return this.post<JsonResponse>(this.urls.actualizarLotes, lotes, this.authService.token);
    }

    obtenerBodegas(bodega: Bodega) {
        return this.post<JsonResponse>(this.urls.obtenerBodegas, bodega, this.authService.token);
    }

    obtenerBodegasPaginado(tamanioPagina: number, pagina: number, idEmpresa: string, activo: boolean) {

        let urlFinal = this.urls.obtenerBodegasPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&IdEmpresa=${idEmpresa}&Activo=${activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerCuentaContable(cuentaContable: CuentaContable) {
        return this.post<JsonResponse>(this.urls.obtenerCuentaContable, cuentaContable, this.authService.token);
    }

    obtenerCuentaContablePaginado(tamanioPagina: number, pagina: number, idEmpresa: string) {

        let urlFinal = this.urls.obtenerCuentaContablePaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&idEmpresa=${idEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarCuentaContable(cuentaContable: CuentaContable) {
        return this.post<JsonResponse>(this.urls.agregarCuentaContable, cuentaContable, this.authService.token);
    }

    actualizarCuentaContable(cuentaContable: CuentaContable) {
        return this.post<JsonResponse>(this.urls.actualizarCuentaContable, cuentaContable, this.authService.token);
    }

    obtenerCodigoOrigen(codigoOrigen: CodigoOrigen) {
        return this.post<JsonResponse>(this.urls.obtenerCodigoOrigen, codigoOrigen, this.authService.token);
    }

    obtenerConsecutivo(consecutivo: Consecutivo) {
        return this.post<JsonResponse>(this.urls.obtenerConsecutivo, consecutivo, this.authService.token);
    }

    obtenerConsecutivoPaginado(tamanioPagina: number, pagina: number, IdEmpresa: string, Origen: string, Activo: boolean) {
        let urlFinal = this.urls.obtenerConsecutivoPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        urlFinal += `&Origen=${Origen}`;
        urlFinal += `&IdEmpresa=${IdEmpresa}`;
        urlFinal += `&Activo=${Activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerConsecutivoParaVincular(consecutivo: Consecutivo) {
        return this.post<JsonResponse>(this.urls.obtenerConsecutivoParaVincular, consecutivo, this.authService.token);
    }

    obtenerConsecutivosParaVincularDisponibles(consecutivo: Consecutivo) {
        return this.post<JsonResponse>(this.urls.obtenerConsecutivosParaVincularDisponibles, consecutivo, this.authService.token);
    }

    obtenerBancos(bancos: Bancos) {
        return this.post<JsonResponse>(this.urls.obtenerBancos, bancos, this.authService.token);
    }

    obtenerPaginadoBancos(tamanioPagina: number, pagina: number, IdEmpresa: string, activo: boolean) {

        let urlFinal = this.urls.obtenerPaginadoBancos + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&IdEmpresa=${IdEmpresa}&activo=${activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerConceptoPago(conceptoPago: ConceptoPago) {
        return this.post<JsonResponse>(this.urls.obtenerConceptoPago, conceptoPago, this.authService.token);
    }

    obtenerConceptoPagoPaginado(tamanioPagina: number, pagina: number, IdEmpresa: string, Origen: string, activo: boolean) {

        let urlFinal = this.urls.obtenerConceptoPagoPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&IdEmpresa=${IdEmpresa}&Origen=${Origen}&Activo=${activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTipoMovBancos(tipoMovBancos: TipoMovBancos) {
        return this.post<JsonResponse>(this.urls.obtenerTipoMovBancos, tipoMovBancos, this.authService.token);
    }

    obtenerTipoMovBancosXBanco(tipoMovBancos: TipoMovBancosXBanco) {
        return this.post<JsonResponse>(this.urls.obtenerTipoMovBancosXBanco, tipoMovBancos, this.authService.token);
    }

    obtenerTipoMovBancosXEmpresa(tipoMovBancos: TipoMovBancos) {
        return this.post<JsonResponse>(this.urls.obtenerTipoMovBancosXEmpresa, tipoMovBancos, this.authService.token);
    }

    obtenerClasificacion(clasificacion: Clasificacion) {
        return this.post<JsonResponse>(this.urls.obtenerClasificacion, clasificacion, this.authService.token);
    }

    obtenerClasificacionPaginado(tamanioPagina: number, pagina: number, idEmpresa: string, orden?: number) {

        let urlFinal = this.urls.obtenerClasificacionPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (orden != undefined && orden != null && orden != 0) {
            urlFinal += `&orden=${orden}`;
        }

        urlFinal += `&idEmpresa=${idEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerMoneda(moneda: Moneda) {

        return this.post<JsonResponse>(this.urls.obtenerMoneda, moneda, this.authService.token);
    }

    obtenerMonedaXEmpresa(monedaXEmpresa: MonedaXEmpresa) {

        return this.post<JsonResponse>(this.urls.obtenerMonedaXEmpresa, monedaXEmpresa, this.authService.token);
    }

    obtenerUnidadMedida(unidadMedida: UnidadMedida) {
        return this.post<JsonResponse>(this.urls.obtenerUnidadMedida, unidadMedida, this.authService.token);
    }

    obtenerListaPrecio(listaPrecio: ListaPrecio) {
        return this.post<JsonResponse>(this.urls.obtenerListaPrecio, listaPrecio, this.authService.token);
    }

    obtenerListaPrecioProducto(listaPrecioProducto: ListaPrecioProducto) {
        return this.post<JsonResponse>(this.urls.obtenerListaPrecioProducto, listaPrecioProducto, this.authService.token);
    }

    obtenerListaPrecioProductoXProducto(IdListaPrecio: any, IdProducto: any) {

        let urlFinal = this.urls.obtenerListaPrecioProductoXProducto + `?IdListaPrecio=${IdListaPrecio}&IdProducto=${IdProducto}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTipoMovimiento(tipoMovimiento: TipoMovimiento) {
        return this.post<JsonResponse>(this.urls.obtenerTipoMovimiento, tipoMovimiento, this.authService.token);
    }

    obtenerTipoTransaccion(tipoTransaccion: TipoTransaccion) {
        return this.post<JsonResponse>(this.urls.obtenerTipoTransaccion, tipoTransaccion, this.authService.token);
    }

    obtenerTipoTransaccionPaginado(tamanioPagina: number, pagina: number, idEmpresa: string, CodigoOrigen?: string, Activo?: boolean) {
        let urlFinal = this.urls.obtenerTipoTransaccionPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (CodigoOrigen != undefined && CodigoOrigen != null && CodigoOrigen != '') {
            urlFinal += `&CodigoOrigen=${CodigoOrigen}`;
        }

        if (Activo != undefined && Activo != null) {
            urlFinal += `&Activo=${Activo}`;
        }

        urlFinal += `&idEmpresa=${idEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTipoTransaccionBase(tipoTransaccionBase: TipoTransaccionBase) {
        return this.post<JsonResponse>(this.urls.obtenerTipoTransaccionBase, tipoTransaccionBase, this.authService.token);
    }

    agregarBodega(bodega: Bodega) {
        return this.post<JsonResponse>(this.urls.agregarBodega, bodega, this.authService.token);
    }

    agregarConsecutivo(consecutivo: Consecutivo) {
        return this.post<JsonResponse>(this.urls.agregarConsecutivo, consecutivo, this.authService.token);
    }

    agregarTipoMovBancos(tipoMovBancos: TipoMovBancos) {
        return this.post<JsonResponse>(this.urls.agregarTipoMovBancos, tipoMovBancos, this.authService.token);
    }

    agregarConceptoPago(conceptoPago: ConceptoPago) {
        return this.post<JsonResponse>(this.urls.agregarConceptoPago, conceptoPago, this.authService.token);
    }

    actualizarBodega(bodega: Bodega) {
        return this.post<JsonResponse>(this.urls.actualizarBodega, bodega, this.authService.token);
    }

    actualizarConsecutivo(consecutivo: Consecutivo) {
        return this.post<JsonResponse>(this.urls.actualizarConsecutivo, consecutivo, this.authService.token);
    }

    actualizarTipoMovBancos(tipoMovBancos: TipoMovBancos) {
        return this.post<JsonResponse>(this.urls.actualizarTipoMovBancos, tipoMovBancos, this.authService.token);
    }

    actualizarTipoMovBancosXBancoLista(tipoMovBancosXBanco: TipoMovBancosXBanco[]) {
        return this.post<JsonResponse>(this.urls.actualizarTipoMovBancosXBancoLista, tipoMovBancosXBanco, this.authService.token);
    }

    actualizarConceptoPago(conceptoPago: ConceptoPago) {
        return this.post<JsonResponse>(this.urls.actualizarConceptoPago, conceptoPago, this.authService.token);
    }

    agregarClasificacion(clasificacion: Clasificacion) {
        return this.post<JsonResponse>(this.urls.agregarClasificacion, clasificacion, this.authService.token);
    }

    actualizarclasificacion(clasificacion: Clasificacion) {
        return this.post<JsonResponse>(this.urls.actualizarclasificacion, clasificacion, this.authService.token);
    }

    agregarListaPrecioCompleto(listaPrecioCompleto: ListaPrecioCompleto) {
        return this.post<JsonResponse>(this.urls.agregarListaPrecioCompleto, listaPrecioCompleto, this.authService.token);
    }

    actualizarListaPrecioCompleto(listaPrecioCompleto: ListaPrecioCompleto) {
        return this.post<JsonResponse>(this.urls.actualizarListaPrecioCompleto, listaPrecioCompleto, this.authService.token);
    }

    agregarUnidadMedida(unidadMedida: UnidadMedida) {
        return this.post<JsonResponse>(this.urls.agregarUnidadMedida, unidadMedida, this.authService.token);
    }

    actualizarUnidadMedida(unidadMedida: UnidadMedida) {
        return this.post<JsonResponse>(this.urls.actualizarUnidadMedida, unidadMedida, this.authService.token);
    }

    agregarTipoMovimiento(tipoMovimiento: TipoMovimiento) {
        return this.post<JsonResponse>(this.urls.agregarTipoMovimiento, tipoMovimiento, this.authService.token);
    }

    actualizarTipoMovimiento(tipoMovimiento: TipoMovimiento) {
        return this.post<JsonResponse>(this.urls.actualizarTipoMovimiento, tipoMovimiento, this.authService.token);
    }

    agregarTipoTransaccion(tipoTransaccion: TipoTransaccion) {
        return this.post<JsonResponse>(this.urls.agregarTipoTransaccion, tipoTransaccion, this.authService.token);
    }

    actualizarTipoTransaccion(tipoTransaccion: TipoTransaccion) {
        return this.post<JsonResponse>(this.urls.actualizarTipoTransaccion, tipoTransaccion, this.authService.token);
    }

    agregarEmpresaMoneda(empresaMoneda: EmpresaMoneda) {
        return this.post<JsonResponse>(this.urls.agregarEmpresaMoneda, empresaMoneda, this.authService.token);
    }

    actualizarEmpresaMoneda(empresaMoneda: EmpresaMoneda) {
        return this.post<JsonResponse>(this.urls.actualizarEmpresaMoneda, empresaMoneda, this.authService.token);
    }

    agregarDocumentosXProyecto(formData: FormData) {
        return this.postFile<JsonResponse>(
            this.urls.agregarDocumentoXProyecto,
            formData,
            this.authService.token
        );
    }

    obtenerDocumentoXProyecto(documento: DocumentoXProyecto) {
        return this.post<JsonResponse>(
            this.urls.obtenerDocumentoXProyecto,
            documento,
            this.authService.token
        );
    }

    obtenerDocumentoXProyectoPaginado(tamanioPagina: number, pagina: number, IdProyecto: any) {

        let urlFinal = this.urls.obtenerDocumentoXProyectoPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (IdProyecto != undefined && IdProyecto != null && IdProyecto != '') {
            urlFinal += `&IdProyecto=${IdProyecto}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    eliminarDocumentoXProyecto(IdDocumento: any) {
        return this.post<JsonResponse>(
            this.urls.eliminarDocumentoXProyecto,
            IdDocumento,
            this.authService.token
        );
    }

    agregarDocumentosXContratoProyecto(formData: FormData) {
        return this.postFile<JsonResponse>(
            this.urls.agregarDocumentoXContratoProyecto,
            formData,
            this.authService.token
        );
    }

    obtenerDocumentoXContratoProyecto(documento: DocumentoXContratoProyecto) {
        return this.post<JsonResponse>(
            this.urls.obtenerDocumentoXContratoProyecto,
            documento,
            this.authService.token
        );
    }

    obtenerDocumentoXContratoProyectoPaginado(tamanioPagina: number, pagina: number, IdProyecto: any) {

        let urlFinal = this.urls.obtenerDocumentoXContratoProyectoPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (IdProyecto != undefined && IdProyecto != null && IdProyecto != '') {
            urlFinal += `&IdProyecto=${IdProyecto}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    eliminarDocumentoXContratoProyecto(IdDocumento: any) {
        return this.post<JsonResponse>(
            this.urls.eliminarDocumentoXContratoProyecto,
            IdDocumento,
            this.authService.token
        );
    }

    agregarDocumentosXProducto(formData: FormData) {
        return this.postFile<JsonResponse>(
            this.urls.agregarDocumentoXProducto,
            formData,
            this.authService.token
        );
    }

    obtenerDocumentoXProducto(documento: DocumentoXProducto) {
        return this.post<JsonResponse>(
            this.urls.obtenerDocumentoXProducto,
            documento,
            this.authService.token
        );
    }

    obtenerDocumentoXProductoPaginado(tamanioPagina: number, pagina: number, IdProducto: any) {

        let urlFinal = this.urls.obtenerDocumentoXProductoPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (IdProducto != undefined && IdProducto != null && IdProducto != '') {
            urlFinal += `&IdProducto=${IdProducto}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    eliminarDocumentoXProducto(IdDocumento: any) {
        return this.post<JsonResponse>(
            this.urls.eliminarDocumentoXProducto,
            IdDocumento,
            this.authService.token
        );
    }

    verificarcatalogosempresaAdmin(empresa: Empresa) {
        return this.post<JsonResponse>(this.urls.verificarcatalogosempresaAdmin, empresa, this.authService.token);
    }

    obtenerGrupos(grupos: Grupos) {
        return this.post<JsonResponse>(this.urls.obtenerGrupos, grupos, this.authService.token);
    }

    agregarGrupos(grupos: Grupos) {
        return this.post<JsonResponse>(this.urls.agregarGrupos, grupos, this.authService.token);
    }

    actualizarGrupos(grupos: Grupos) {
        return this.post<JsonResponse>(this.urls.actualizarGrupos, grupos, this.authService.token);
    }

    actualizarFuncion(funcion: FuncionesNomina) {
        return this.post<JsonResponse>(this.urls.actualizarFuncion, funcion, this.authService.token);
    }

    agregarFuncion(funcion: FuncionesNomina) {
        return this.post<JsonResponse>(this.urls.agregarFuncion, funcion, this.authService.token);
    }

    obtenerFuncionPaginado(tamanioPagina: number, pagina: number, IdPais: any, Activo?: boolean) {

        let urlFinal = this.urls.obtenerFuncionPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        urlFinal += `&IdPais=${IdPais}`;

        if (Activo != null) {
            urlFinal += `&Activo=${Activo}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    actualizarConcepto(concepto: Conceptos) {
        return this.post<JsonResponse>(this.urls.actualizarConcepto, concepto, this.authService.token);
    }

    agregarConceptosLiquidacionLista(conceptoPaginado: Conceptos) {
        return this.post<JsonResponse>(this.urls.agregarConceptosLiquidacionLista, conceptoPaginado, this.authService.token);
    }

    agregarConcepto(concepto: Conceptos) {
        return this.post<JsonResponse>(this.urls.agregarConcepto, concepto, this.authService.token);
    }

    obtenerConceptoPaginado(tamanioPagina: number, pagina: number, IdPais: any, Activo?: boolean) {

        let urlFinal = this.urls.obtenerConceptoPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        urlFinal += `&IdPais=${IdPais}`;

        if (Activo != null) {
            urlFinal += `&Activo=${Activo}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerConcepto(concepto: Conceptos) {
        return this.post<JsonResponse>(this.urls.obtenerConcepto, concepto, this.authService.token);
    }

    obtenerSubGrupo(SubGrupo: SubGrupo) {
        return this.post<JsonResponse>(this.urls.obtenerSubGrupo, SubGrupo, this.authService.token);
    }

    obtenerFuncionesNomina(FuncionesNomina: FuncionesNomina) {
        return this.post<JsonResponse>(this.urls.obtenerFuncionesNomina, FuncionesNomina, this.authService.token);
    }

    obtenerCatalogosModulo(catalogo: Catalogo) {
        return this.post<JsonResponse>(this.urls.obtenerCatalogosModulo, catalogo, this.authService.token);
    }

    obtenerListaModulos(modulo: Modulo) {
        return this.post<JsonResponse>(this.urls.obtenerListaModulos, modulo, this.authService.token);
    }

    obtenerListaModulosXMenuLicencia(activo: boolean, esSistema: boolean, IdTipoLicencia: any) {
        let urlFinal = this.urls.obtenerListaModulosXMenuLicencia + `?esSistema=${esSistema}&Activo=${activo}&IdTipoLicencia=${IdTipoLicencia}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    registrarRenovacionLicenciaEmpresa(registroOrdenesCompraEmpresa: RegistroOrdenesCompraEmpresa) {

        return this.post<JsonResponse>(this.urls.registrarRenovacionLicenciaEmpresa, registroOrdenesCompraEmpresa, this.authService.token);
    }

    agregarTimbresEmpresa(agregarRemoverTimbres: AgregarRemoverTimbres) {

        return this.post<JsonResponse>(this.urls.agregarTimbresEmpresa, agregarRemoverTimbres, this.authService.token);
    }

    obtenerTipoLicencia(tipoLicencia: TipoLicencia) {

        return this.post<JsonResponse>(this.urls.obtenerTipoLicencia, tipoLicencia, this.authService.token);
    }

    registrarEmpresaSW(empresa: Empresa) {

        return this.post<JsonResponse>(this.urls.registrarEmpresaSW, empresa, this.authService.token);
    }

    obtenerMenuAdministracionSistemas() {

        return this.get<JsonResponse>(this.urls.obtenerMenuAdministracionSistemas, this.authService.token);
    }

    obtenerEmpresa(empresa: Empresa) {

        return this.post<JsonResponse>(this.urls.obtenerEmpresa, empresa, this.authService.token);
    }

    obtenerEmpresaCompleta(empresa: Empresa) {

        return this.post<JsonResponse>(this.urls.obtenerEmpresaCompleta, empresa, this.authService.token);
    }

    obtenerPaginadoEmpresa(tamanioPagina: number, pagina: number, IdEmpresa: any, activo: boolean) {

        let urlFinal = this.urls.obtenerPaginadoEmpresa + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&IdEmpresa=${IdEmpresa}&activo=${activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerMenuUsuario(usuario: Usuario) {

        return this.post<JsonResponse>(this.urls.obtenerMenuUsuario, usuario, this.authService.token);
    }

    actualizarPerfil(perfil: Perfil) {

        return this.post<JsonResponse>(this.urls.actualizarPerfil, perfil, this.authService.token);
    }

    agregarPerfil(perfil: Perfil) {

        return this.post<JsonResponse>(this.urls.agregarPerfil, perfil, this.authService.token);
    }

    obtenerPerfilPaginado(tamanioPagina: number, pagina: number, esAdministrador: boolean, esConsulta: boolean, esSistema: boolean, activo: boolean) {

        let urlFinal = this.urls.obtenerPerfilPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&esAdministrador=${esAdministrador}&esConsulta=${esConsulta}&esSistema=${esSistema}&activo=${activo}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerPerfil(perfil: Perfil) {

        return this.post<JsonResponse>(this.urls.obtenerPerfil, perfil, this.authService.token);
    }

    obtenerMenu(menu: Menu) {

        return this.post<JsonResponse>(this.urls.obtenerMenu, menu, this.authService.token);
    }

    obtenerMenuCompleto(activo: boolean, esSistema: boolean, IdTipoLicencia: any, IdPerfil: any) {

        let urlFinal = this.urls.obtenerMenuCompleto + `?esSistema=${esSistema}&Activo=${activo}&IdTipoLicencia=${IdTipoLicencia}&IdPerfil=${IdPerfil}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerMenuPerfiles(IdPerfil: any, IdTipoLicencia: any) {

        let urlFinal = this.urls.obtenerMenuPerfiles + `?IdTipoLicencia=${IdTipoLicencia}&IdPerfil=${IdPerfil}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    guardarMenuCompleto(listaMenu: Menu[]) {

        return this.post<JsonResponse>(this.urls.guardarMenuCompleto, listaMenu, this.authService.token);
    }

    agregarMenu(menu: Menu) {

        return this.post<JsonResponse>(this.urls.agregarMenu, menu, this.authService.token);
    }

    obtenerConfiguracionGlobal(configuracionGlobal: ConfiguracionGlobal) {
        return this.post<JsonResponse>(this.urls.obtenerConfiguracionGlobal, configuracionGlobal, this.authService.token);
    }

    obtenerConfiguracionGlobalEmpresa(configuracionGlobal: ConfiguracionGlobalEmpresa) {
        return this.post<JsonResponse>(this.urls.obtenerConfiguracionGlobalEmpresa, configuracionGlobal, this.authService.token);
    }

    obtenerTipoVariable(tipoVariable: TipoVariable) {
        return this.post<JsonResponse>(this.urls.obtenerTipoVariable, tipoVariable, this.authService.token);
    }

    agregarTipoVariable(tipoVariable: TipoVariable) {
        return this.post<JsonResponse>(this.urls.agregarTipoVariable, tipoVariable, this.authService.token);
    }

    actualizarTipoVariable(tipoVariable: TipoVariable) {
        return this.post<JsonResponse>(this.urls.actualizarTipoVariable, tipoVariable, this.authService.token);
    }

    obtenerProductoCompleto(tamanioPagina: number, pagina: number, nombre: string, idEmpresa: string, activo?: boolean) {

        let urlFinal = this.urls.obtenerProductoCompleto + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (nombre != undefined && nombre != null && nombre != '') {
            urlFinal += `&nombre=${nombre}`;
        }

        if (activo != undefined && activo != null) {
            urlFinal += `&activo=${activo}`;
        }

        if (idEmpresa != null)
            urlFinal += `&idEmpresa=${idEmpresa}`

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerDocumentoXProductoCompleto(tamanioPagina: number, pagina: number, IdProducto: any) {

        let urlFinal = this.urls.obtenerDocumentoXProductoCompleto + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (IdProducto != undefined && IdProducto != null && IdProducto != '') {
            urlFinal += `&IdProducto=${IdProducto}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    ///    

    catalogoObtenerBanco(banco?: Banco) {
        return this.post<JsonResponse>(this.urls.catalogoObtenerBanco, banco, this.authService.token);
    }

    obtenerConsecutivoBanco(consecutivo?: ConsecutivoCodigoBanco) {
        return this.post<JsonResponse>(this.urls.obtenerConsecutivoBanco, consecutivo, this.authService.token);
    }

    obtenerPaginadoPagoClienteSustitucion(tamanioPagina: number, pagina: number, IdTercero: any) {

        let urlFinal = this.urls.obtenerPaginadoPagoClienteSustitucion + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}&IdTercero=${IdTercero}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarComprador(vendedor: Comprador) {

        return this.post<JsonResponse>(this.urls.agregarComprador, vendedor, this.authService.token);
    }

    agregarVendedor(vendedor: Vendedor) {

        return this.post<JsonResponse>(this.urls.agregarVendedor, vendedor, this.authService.token);
    }

    agregarBancos(bancos: Bancos) {

        return this.post<JsonResponse>(this.urls.agregarBancos, bancos, this.authService.token);
    }

    actualizarBancos(bancos: Bancos) {

        return this.post<JsonResponse>(this.urls.actualizarBancos, bancos, this.authService.token);
    }

    verificarCatalogosBancos(IdEmpresa: any) {

        //console.log('verificarCatologBancos');

        const urlFinal = this.urls.verificarCatalogosBancos + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    verificarCatalogosTerceros(IdPais: any, IdEmpresa: any) {

        //console.log('verificarCatologTercero');

        const urlFinal = this.urls.verificarCatalogosTerceros + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarEmpresaTercero(tercero: Tercero) {

        return this.post<JsonResponse>(this.urls.agregarEmpresaTercero, tercero, this.authService.token);
    }

    agregarProducto(producto: Producto) {

        return this.post<JsonResponse>(this.urls.agregarProducto, producto, this.authService.token);
    }

    public toBase64(files: File[], selectedFiles: SelectedFiles[]): Observable<SelectedFiles[]> {
        const result = new AsyncSubject<SelectedFiles[]>();
        let count = 0;
        if (files?.length) {
            Object.keys(files)?.forEach((file, i) => {
                const url = URL.createObjectURL(files[i]);
                const reader = new FileReader();
                reader.readAsDataURL(files[i]);
                reader.onload = (e) => {
                    selectedFiles = selectedFiles?.filter(f => f?.name != files[i]?.name);
                    count++;
                    selectedFiles.push({ id: count, name: files[i]?.name, file: files[i], base64: reader?.result as string, url: url });
                    result.next(selectedFiles);
                    if (files?.length === (i + 1)) {
                        result.complete();
                    }
                };
            });
            return result;
        } else {
            result.next([]);
            result.complete();
            return result;
        }
    }

    actualizarContrasenaUsuario(usuario: Usuario) {

        return this.post<JsonResponse>(this.urls.actualizarContrasenaUsuario, usuario, this.authService.token);
    }

    guardarAvatar(documento: Documento) {

        return this.post<JsonResponse>(this.urls.guardarAvatar, documento, this.authService.token);
    }

    obtenerCuentaXPagarDistribucionSaldosPagos(idPagoProveedor: any) {

        let urlFinal = this.urls.obtenerCuentaXPagarDistribucionSaldosPagos + `?idPagoProveedor=${idPagoProveedor}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerCobranzaDistribucionSaldosAbonos(idPagoCliente?: any, IdTransaccionComercial?: any) {

        let urlFinal = this.urls.obtenerCobranzaDistribucionSaldosAbonos;

        if (idPagoCliente != null)
            urlFinal += `?idPagoCliente=${idPagoCliente}`;


        if (IdTransaccionComercial != null)
            urlFinal += `?IdTransaccionComercial=${IdTransaccionComercial}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerInforTransaccionComercialCompleta(IdTransaccionComercial: any) {

        let urlFinal = this.urls.obtenerInforTransaccionComercialCompleta + `?IdTransaccionComercial=${IdTransaccionComercial}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarPagoClienteCompleto(pagoClienteCompleto: PagoClienteCompleto) {

        return this.post<JsonResponse>(this.urls.agregarPagoClienteCompleto, pagoClienteCompleto, this.authService.token);
    }

    actualizarPagoClienteCompleto(pagoClienteCompleto: PagoClienteCompleto) {

        return this.post<JsonResponse>(this.urls.actualizarPagoClienteCompleto, pagoClienteCompleto, this.authService.token);
    }

    agregarPagoProveedorCompleto(pagoProveedorCompleto: PagoProveedorCompleto) {

        return this.post<JsonResponse>(this.urls.agregarPagoProveedorCompleto, pagoProveedorCompleto, this.authService.token);
    }

    actualizarPagoProveedorCompleto(pagoProveedorCompleto: PagoProveedorCompleto) {

        return this.post<JsonResponse>(this.urls.actualizarPagoProveedorCompleto, pagoProveedorCompleto, this.authService.token);
    }

    verificarCatalogosPagosCobranza(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosPagosCobranza + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    verificarCatalogosPagosProveedor(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosPagosProveedor + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    eliminarChats(chats: Chats) {

        return this.post<JsonResponse>(this.urls.eliminarChats, chats, this.authService.token);
    }

    obtenerChatsUsuario(idEmpresa: string, idUsuarioConectado) {

        let urlFinal = this.urls.obtenerChatsUsuario + `?idEmpresa=${idEmpresa}&idUsuarioConectado=${idUsuarioConectado}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarActualizarChats(chats: Chats) {

        return this.post<JsonResponse>(this.urls.agregarActualizarChats, chats, this.authService.token);
    }

    eliminarTarea(tarea: Tareas) {

        return this.post<JsonResponse>(this.urls.eliminarTarea, tarea, this.authService.token);
    }

    obtenerEstatusTarea(estatusTarea: EstatusTarea) {

        return this.post<JsonResponse>(this.urls.obtenerEstatusTarea, estatusTarea, this.authService.token);
    }

    obtenerUsuarioAgrupado(idEmpresa: string, idUsuarioConectado, activo: boolean) {

        let urlFinal = this.urls.obtenerUsuarioAgrupado;

        if (idEmpresa != undefined && idEmpresa != null && idEmpresa != '') {
            urlFinal += `&idEmpresa=${idEmpresa}`;
        }

        if (idUsuarioConectado != undefined && idUsuarioConectado != null && idUsuarioConectado != '') {
            urlFinal += `&idUsuarioConectado=${idUsuarioConectado}`;
        }

        if (activo != undefined && activo != null) {
            urlFinal += `&activo=${activo}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarTareaXNota(tareasXNotas: TareasXNotas) {

        return this.post<JsonResponse>(this.urls.agregarTareaXNota, tareasXNotas, this.authService.token);
    }

    agregarTareaXDocumento(tareasXDocumento: TareasXDocumento) {

        return this.post<JsonResponse>(this.urls.agregarTareaXDocumento, tareasXDocumento, this.authService.token);
    }

    agregarTareas(tareas: Tareas) {

        return this.post<JsonResponse>(this.urls.agregarTareas, tareas, this.authService.token);
    }

    actualizarTareas(tareas: Tareas) {

        return this.post<JsonResponse>(this.urls.actualizarTareas, tareas, this.authService.token);
    }

    actualizarTareasAdministrador(tareas: Tareas) {

        return this.post<JsonResponse>(this.urls.actualizarTareasAdministrador, tareas, this.authService.token);
    }

    obtenerTareasXUsuario(tareas: Tareas) {

        return this.post<JsonResponse>(this.urls.obtenerTareasXUsuario, tareas, this.authService.token);
    }

    obtenerTareasXUsuariosAdmin(IdEmpresa: any) {

        let urlFinal = this.urls.obtenerTareasXUsuariosAdmin + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTareas(tareas: Tareas) {

        return this.post<JsonResponse>(this.urls.obtenerTareas, tareas, this.authService.token);
    }

    eliminarDocumento(tareaXDocumento: TareasXDocumento) {

        return this.post<JsonResponse>(this.urls.eliminarDocumento, tareaXDocumento, this.authService.token);
    }

    verificarCatalogosConfiguracionGlobal(IdTipoLicencia?: any) {

        let urlFinal = this.urls.verificarCatalogosConfiguracionGlobal;

        if (IdTipoLicencia != null) {
            urlFinal += `?IdTipoLicencia=${IdTipoLicencia}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarConfiguracionGlobal(configuracionGlobal: ConfiguracionGlobal) {

        return this.post<JsonResponse>(this.urls.agregarConfiguracionGlobal, configuracionGlobal, this.authService.token);
    }

    actualizarConfiguracionGlobal(configuracionGlobal: ConfiguracionGlobal) {

        return this.post<JsonResponse>(this.urls.actualizarConfiguracionGlobal, configuracionGlobal, this.authService.token);
    }

    actualizarConfiguracionGlobalJSON(listaConfiguracionGlobal: ConfiguracionGlobal[]) {

        return this.post<JsonResponse>(this.urls.actualizarConfiguracionGlobalJSON, listaConfiguracionGlobal, this.authService.token);
    }

    actualizarConfiguracionGlobalEmpresa(configuracionGlobal: ConfiguracionGlobalEmpresa) {

        return this.post<JsonResponse>(this.urls.actualizarConfiguracionGlobalEmpresa, configuracionGlobal, this.authService.token);
    }

    /// Bancos ///

    verificarCatalogosMovimientosBancarios(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosMovimientosBancarios + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    agregarListaMovimientosBancos(listaMovimientosBancos: MovimientoBancos[]) {

        return this.post<JsonResponse>(this.urls.agregarListaMovimientosBancos, listaMovimientosBancos, this.authService.token);
    }

    obtenerMovimientosBancariosXFechas(movimientoBancos: MovimientoBancos) {

        return this.post<JsonResponse>(this.urls.obtenerMovimientosBancariosXFechas, movimientoBancos, this.authService.token);
    }

    verificarCatalogosSaldoBancos(IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosSaldoBancos + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }


    /// Ventas ///

    verificarCatalogosBusquedaDocumentosVentas(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosBusquedaDocumentosVentas + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTransaccionComercial(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.obtenerTransaccionComercial, transaccionComercial, this.authService.token);
    }

    obtenerTransaccionComercialV2(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.obtenerTransaccionComercialV2, transaccionComercial, this.authService.token);
    }

    obtenerTransaccionComercialDetalle(transaccionComercialDetalle: TransaccionComercialDetalle) {

        return this.post<JsonResponse>(this.urls.obtenerTransaccionComercialDetalle, transaccionComercialDetalle, this.authService.token);
    }

    reenviarFactura(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.reenviarFactura, transaccionComercial, this.authService.token);
    }

    obtenerAñoMesTransaccionComercial(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.obtenerAñoMesTransaccionComercial, transaccionComercial, this.authService.token);
    }

    revisarFactura(IdTransaccionComercial, mostrarPrecios) {

        let urlFinal = this.urls.revisarFactura + `?IdTransaccionComercial=${IdTransaccionComercial}`;

        if (mostrarPrecios != undefined && mostrarPrecios != null) {
            urlFinal += `&mostrarPrecios=${mostrarPrecios}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    revisarSaldosInventario(saldoAlmacen: SaldoAlmacen) {

        return this.post<JsonResponse>(this.urls.revisarSaldosInventario, saldoAlmacen, this.authService.token);
    }

    revisarSaldosInventarioBodega(saldoAlmacen: SaldoAlmacen) {

        return this.post<JsonResponse>(this.urls.revisarSaldosInventarioBodega, saldoAlmacen, this.authService.token);
    }

    revisarProductosAntesDeDuplicarTransaccionComercialCompleta(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.revisarProductosAntesDeDuplicarTransaccionComercialCompleta, transaccionComercial, this.authService.token);
    }

    duplicarTransaccionComercialCompleta(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.duplicarTransaccionComercialCompleta, transaccionComercial, this.authService.token);
    }

    obtenerInfoTimbradoFEMexico(IdTransaccionComercial) {
        let urlFinal = this.urls.obtenerInfoTimbradoFEMexico + `?IdTransaccionComercial=${IdTransaccionComercial}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerInfoTimbradoFEMexicoPagoCliente(IdPagoCliente) {
        let urlFinal = this.urls.obtenerInfoTimbradoFEMexicoPagoCliente + `?IdPagoCliente=${IdPagoCliente}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    leerXMLVincularDocumentoVentas(documentoXML: DocumentoXML) {

        return this.post<JsonResponse>(this.urls.leerXMLVincularDocumentoVentas, documentoXML, this.authService.token);

    }

    leerXMLVincularPagoCliente(documentoXML: DocumentoXML) {

        return this.post<JsonResponse>(this.urls.leerXMLVincularPagoCliente, documentoXML, this.authService.token);

    }

    obtenerListaUUIDRelacionados(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.obtenerListaUUIDRelacionados, transaccionComercial, this.authService.token);
    }

    actualizarTransaccionComercial(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.actualizarTransaccionComercial, transaccionComercial, this.authService.token);
    }

    vincularFacturaVentaXML(vincularXML: VincularXMLDocumentos) {

        return this.post<JsonResponse>(this.urls.vincularFacturaVentaXML, vincularXML, this.authService.token);

    }

    vincularPagoClienteXML(vincularXML: VincularXMLDocumentos) {

        return this.post<JsonResponse>(this.urls.vincularPagoClienteXML, vincularXML, this.authService.token);

    }

    cancelarTransaccionComercial(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.cancelarTransaccionComercial, transaccionComercial, this.authService.token);
    }

    generarContabilidadVentasMX(listaTransaccionComercial: TransaccionComercial[]) {
        return this.post<JsonResponse>(this.urls.generarContabilidadVentasMX, listaTransaccionComercial, this.authService.token);
    }

    obtenerTimbradoFEMexico(listaTransaccionComercial: any[]) {
        return this.post<JsonResponse>(this.urls.obtenerTimbradoFEMexico, listaTransaccionComercial, this.authService.token);
    }

    reporteTransaccionComercialPaginado(listaTransaccionComercialPaginado: TransaccionComercialPaginado[]) {

        return this.post<JsonResponse>(this.urls.reporteTransaccionComercialPaginado, listaTransaccionComercialPaginado, this.authService.token);
    }

    obtenerCobranzaGeneral(cobranzaGeneral: CobranzaGeneral) {

        return this.post<JsonResponse>(this.urls.obtenerCobranzaGeneral, cobranzaGeneral, this.authService.token);
    }

    obtenerCobranzaResumenDeudaPorCliente(cobranzaGeneral: CobranzaGeneral) {

        return this.post<JsonResponse>(this.urls.obtenerCobranzaResumenDeudaPorCliente, cobranzaGeneral, this.authService.token);
    }

    obtenerDetalleCobranzasPorTransaccionComercial(idTransaccionComercial: any) {

        let urlFinal = this.urls.obtenerDetalleCobranzasPorTransaccionComercial + `?IdTransaccionComercial=${idTransaccionComercial}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTransaccionComercialDesdeDetalleOrig(IdDetalleOrig: any) {

        let urlFinal = this.urls.obtenerTransaccionComercialDesdeDetalleOrig + `?IdDetalleOrig=${IdDetalleOrig}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    convertirpedidoAOrdenCompra(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.convertirpedidoAOrdenCompra, transaccionComercial, this.authService.token);
    }

    obtenerTransaccionComercialDocumentosNoRelacionados(factura: boolean, compras: boolean, inventar: boolean, IdCliente: string) {

        let urlFinal = this.urls.obtenerTransaccionComercialDocumentosNoRelacionados + `?`;

        if (IdCliente != undefined && IdCliente != null && IdCliente != '') {
            urlFinal += `IdCliente=${IdCliente}`;
        }

        if (factura != undefined && factura != null) {
            urlFinal += `&factura=${factura}`;
        }

        if (compras != undefined && compras != null) {
            urlFinal += `&compras=${compras}`;
        }

        if (inventar != undefined && inventar != null) {
            urlFinal += `&inventar=${inventar}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    verificarCatalogosDocumentosVentas(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosDocumentosVentas + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    InfoProductoBodega(filtros: { IdEmpresa?: any, IdProducto?: any, YY?: number, MM?: number }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.InfoProductoBodega}?${queryString}`
            : this.urls.InfoProductoBodega;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    InfoSaldosInventarios(filtros: { IdEmpresa?: any, IdProducto?: any, YY?: number, MM?: number, IdBodega?: any, IdLote?: any }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.InfoSaldosInventarios}?${queryString}`
            : this.urls.InfoSaldosInventarios;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTasaCambio(tasaCambio: TasaCambioCatalogo) {

        return this.post<JsonResponse>(this.urls.obtenerTasaCambio, tasaCambio, this.authService.token);
    }

    obtenerTasaCambioDOF() {

        return this.get<JsonResponse>(this.urls.obtenerTasaCambioDOF, this.authService.token);
    }

    obtenerTasaConversion(tasaConversion: TasaConversion) {

        return this.post<JsonResponse>(this.urls.obtenerTasaConversion, tasaConversion, this.authService.token);
    }

    obtenerTasaCambioRangoInsertar(IdPais: any, FechaInicio: Date, FechaFinal: Date) {

        const fechaInicioStr = moment(FechaInicio).format('YYYY-MM-DD');
        const fechaFinalStr = moment(FechaFinal).format('YYYY-MM-DD');

        const params = new HttpParams()
            .set('IdPais', IdPais)
            .set('FechaInicio', fechaInicioStr)
            .set('FechaFinal', fechaFinalStr);

        let urlFinal = `${this.urls.obtenerTasaCambioRangoInsertar}?${params.toString()}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerClavePedimento(clavePedimento: ClavePedimento) {

        return this.post<JsonResponse>(this.urls.obtenerClavePedimento, clavePedimento, this.authService.token);
    }

    obtenerClaveIncoterm(claveIncoterm: ClaveIncoterm) {

        return this.post<JsonResponse>(this.urls.obtenerClaveIncoterm, claveIncoterm, this.authService.token);
    }

    obtenerPais(pais: Pais) {

        return this.post<JsonResponse>(this.urls.obtenerPais, pais, this.authService.token);
    }

    revisarLicenciasEmpresa() {

        return this.get<JsonResponse>(this.urls.revisarLicenciasEmpresa, this.authService.token);
    }

    agregarTransaccionComercialCompleta(transaccionComercialCompleta: TransaccionComercialCompleta) {

        return this.post<JsonResponse>(this.urls.agregarTransaccionComercialCompleta, transaccionComercialCompleta, this.authService.token);
    }

    registrarEntradaTransaccionComercialCompleta(transaccionComercialCompleta: TransaccionComercialCompleta) {

        return this.post<JsonResponse>(this.urls.registrarEntradaTransaccionComercialCompleta, transaccionComercialCompleta, this.authService.token);
    }

    revisarSaldoProductoEmpresa(saldoAlmacen: SaldoAlmacen) {

        return this.post<JsonResponse>(this.urls.revisarSaldoProductoEmpresa, saldoAlmacen, this.authService.token);
    }

    revisarSaldoProductoLote(saldoAlmacen: SaldoAlmacen) {

        return this.post<JsonResponse>(this.urls.revisarSaldoProductoLote, saldoAlmacen, this.authService.token);
    }

    obtenerLotesXProducto(filtros: {IdEmpresa?: any, IdBodega?: any, IdProducto?: any, YY?: number, MM?: number }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerLotesXProducto}?${queryString}`
            : this.urls.obtenerLotesXProducto;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTodosLotesEmpresaXProducto(filtros: { IdEmpresa?: any, IdBodega?: any, IdProducto?: any, YY?: number, MM?: number }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerTodosLotesEmpresaXProducto}?${queryString}`
            : this.urls.obtenerTodosLotesEmpresaXProducto;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTransaccionComercialDocumentosNoRelacionadosPaginado(tamanioPagina: number, pagina: number,
        factura: boolean, compras: boolean, inventar: boolean,
        IdCliente: string) {

        let urlFinal = this.urls.obtenerTransaccionComercialDocumentosNoRelacionadosPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (IdCliente != undefined && IdCliente != null && IdCliente != '') {
            urlFinal += `&IdCliente=${IdCliente}`;
        }

        if (factura != undefined && factura != null) {
            urlFinal += `&factura=${factura}`;
        }

        if (compras != undefined && compras != null) {
            urlFinal += `&compras=${compras}`;
        }

        if (inventar != undefined && inventar != null) {
            urlFinal += `&inventar=${inventar}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTransaccionComercialVentasDocumentosARelacionarPaginado(tamanioPagina: number, pagina: number,
        factura: boolean, compras: boolean, inventar: boolean,
        nombre: string, identificador: string,
        idEmpresa: string, IdTercero: string, IdProyecto: string,
        Ano: string, Mes: string, usuarioConectado: string, ClaveTipoTransaccion: string) {

        let urlFinal = this.urls.obtenerTransaccionComercialVentasDocumentosARelacionarPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (nombre != undefined && nombre != null && nombre != '') {
            urlFinal += `&nombre=${nombre}`;
        }

        if (identificador != undefined && identificador != null && identificador != '') {
            urlFinal += `&identificador=${identificador}`;
        }

        urlFinal += `&idEmpresa=${idEmpresa}`;

        urlFinal += `&usuarioConectado=${usuarioConectado}`;

        if (IdProyecto != undefined && IdProyecto != null && IdProyecto != '') {
            urlFinal += `&IdProyecto=${IdProyecto}`;
        }

        if (IdTercero != undefined && IdTercero != null && IdTercero != '') {
            urlFinal += `&IdTercero=${IdTercero}`;
        }

        if (Ano != undefined && Ano != null && Ano != '') {
            urlFinal += `&Ano=${Ano}`;
        }

        if (Mes != undefined && Mes != null && Mes != '') {
            urlFinal += `&Mes=${Mes}`;
        }

        if (factura != undefined && factura != null) {
            urlFinal += `&factura=${factura}`;
        }

        if (compras != undefined && compras != null) {
            urlFinal += `&compras=${compras}`;
        }

        if (inventar != undefined && inventar != null) {
            urlFinal += `&inventar=${inventar}`;
        }

        if (ClaveTipoTransaccion != undefined && ClaveTipoTransaccion != null) {
            urlFinal += `&ClaveTipoTransaccion=${ClaveTipoTransaccion}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    verificarCatalogosDocumentosVentasModificar(IdPais: any, IdEmpresa: any, IdTipoTransaccion: any) {

        const urlFinal = this.urls.verificarCatalogosDocumentosVentasModificar + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}&IdTipoTransaccion=${IdTipoTransaccion}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerRelacionesSAT(relacionesSAT: RelacionesSAT) {

        return this.post<JsonResponse>(this.urls.obtenerRelacionesSAT, relacionesSAT, this.authService.token);
    }

    actualizarTransaccionComercialCompleta(transaccionComercialCompleta: TransaccionComercialCompletaActualizar) {

        return this.post<JsonResponse>(this.urls.actualizarTransaccionComercialCompleta, transaccionComercialCompleta, this.authService.token);
    }

    obtenerTransaccionComercialUnionDocumentosRelacionados(factura: boolean, compras: boolean, inventar: boolean, IdCliente: string) {

        let urlFinal = this.urls.obtenerTransaccionComercialUnionDocumentosRelacionados + `?`;

        if (IdCliente != undefined && IdCliente != null && IdCliente != '') {
            urlFinal += `IdCliente=${IdCliente}`;
        }

        if (factura != undefined && factura != null) {
            urlFinal += `&factura=${factura}`;
        }

        if (compras != undefined && compras != null) {
            urlFinal += `&compras=${compras}`;
        }

        if (inventar != undefined && inventar != null) {
            urlFinal += `&inventar=${inventar}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTransaccionComercialUnionDocumentosRelacionadosPaginado(tamanioPagina: number, pagina: number,
        factura: boolean, compras: boolean, inventar: boolean,
        IdCliente: string) {

        let urlFinal = this.urls.obtenerTransaccionComercialUnionDocumentosRelacionadosPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (IdCliente != undefined && IdCliente != null && IdCliente != '') {
            urlFinal += `&IdCliente=${IdCliente}`;
        }

        if (factura != undefined && factura != null) {
            urlFinal += `&factura=${factura}`;
        }

        if (compras != undefined && compras != null) {
            urlFinal += `&compras=${compras}`;
        }

        if (inventar != undefined && inventar != null) {
            urlFinal += `&inventar=${inventar}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTransaccionComercialAsociarOrdenCompra(filtros: {factura: boolean, compras: boolean, inventar?: boolean, IdTransaccionComercial?: string, IdEmpresa?: string, IdTercero?: string, Ano?: string, Mes?: string}) {
        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerTransaccionComercialAsociarOrdenCompra}?${queryString}`
            : this.urls.obtenerTransaccionComercialAsociarOrdenCompra;

        return this.get<JsonResponse>(urlFinal, this.authService.token);        
    }

    /// Cobranza ///

    obtenerListaSATMotivo(mtSATMotivoCancela: MtSATMotivoCancela) {

        return this.post<JsonResponse>(this.urls.obtenerListaSATMotivo, mtSATMotivoCancela, this.authService.token);
    }

    verificarCatalogosCobranza(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosCobranza + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerPagoClienteComplemento(filtros: {
        IdPagoCliente?: any;
        IdEmpresa?: any;
        IdTipoTransaccion?: any;
        IdBanco?: any;
        numeroDocumento?: string;
        Fecha?: string;
        FechaRegistroInicial: string,
        FechaRegistroFinal: string,
        activo?: boolean;
        IdMoneda?: any;
        documentoTimbrado?: boolean;
        documentoPorCancelar?: boolean;
        usuarioConectado?: any;
        bloqueado?: boolean;
    }) {
        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerPagoClienteComplemento}?${queryString}`
            : this.urls.obtenerPagoClienteComplemento;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerTimbradoCobranza(timbradoPagoCliente: TimbradoPagoCliente) {
        return this.post<JsonResponse>(this.urls.obtenerTimbradoCobranza, timbradoPagoCliente, this.authService.token);
    }

    sustituirCancelacionPagoCliente(IdPagoCliente: any) {

        const urlFinal = this.urls.sustituirCancelacionPagoCliente + `?IdPagoCliente=${IdPagoCliente}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerListaUUIDPagoClienteRelacionado(IdPagoCliente: any) {
        const urlFinal = this.urls.obtenerListaUUIDPagoClienteRelacionado + `?IdPagoCliente=${IdPagoCliente}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);

    }

    actualizarPagoCliente(pagoCliente: PagoCliente) {

        return this.post<JsonResponse>(this.urls.actualizarPagoCliente, pagoCliente, this.authService.token);
    }

    revisarComprobantePago(IdPagoCliente) {

        const urlFinal = this.urls.revisarComprobantePago + `?IdPagoCliente=${IdPagoCliente}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    reenviarComplementoPago(pagoClientePaginado: PagoClienteComplemento) {

        return this.post<JsonResponse>(this.urls.reenviarComplementoPago, pagoClientePaginado, this.authService.token);
    }

    cancelarPagoCliente(pagoCliente: PagoCliente) {

        return this.post<JsonResponse>(this.urls.cancelarPagoCliente, pagoCliente, this.authService.token);
    }

    // Inventarios //

    verificarCatalogosBusquedaDocumentosInventario(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosBusquedaDocumentosInventario + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerListaTerceros(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.obtenerListaTerceros, transaccionComercial, this.authService.token);
    }

    verificarCatalogosMovimientosAlmacen(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosMovimientosAlmacen + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerBodegaXSaldoAlmacen(IdEmpresa: any, YY?: number) {
        let urlFinal = this.urls.obtenerBodegaXSaldoAlmacen + `?IdEmpresa=${IdEmpresa}`;

        if (YY != null && YY != undefined) {
            urlFinal += `&YY=${YY}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    revisarLotesXProducto(lotes: Lotes) {

        return this.post<JsonResponse>(this.urls.revisarLotesXProducto, lotes, this.authService.token);
    }

    agregarLotesYProducto(lotes: Lotes) {

        return this.post<JsonResponse>(this.urls.agregarLotesYProducto, lotes, this.authService.token);
    }

    verificarCatalogosSaldoInventarios(IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosSaldoInventarios + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerAnoMesSaldoAlmacen(IdProducto: any) {

        const urlFinal = this.urls.obtenerAnoMesSaldoAlmacen + `?IdProducto=${IdProducto}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerProductoConSaldoYMovimientos(filtros: { IdEmpresa: any, YY: number, MM: number, IdBodega?: any, IdProducto?: any, IdLote?: any }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerProductoConSaldoYMovimientos}?${queryString}`
            : this.urls.obtenerProductoConSaldoYMovimientos;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerProductoDeBodegaConSaldo(filtros: { IdEmpresa: any, IdBodega: any, YY: number, MM: number }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerProductoDeBodegaConSaldo}?${queryString}`
            : this.urls.obtenerProductoDeBodegaConSaldo;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    eliminarTransaccionComercialCompleta(transaccionComercialCompleta: TransaccionComercialCompleta) {

        return this.post<JsonResponse>(this.urls.eliminarTransaccionComercialCompleta, transaccionComercialCompleta, this.authService.token);
    }

    obtenerDashboardVentasCompleto(idEmpresa: string, anioSeleccionado: number, fechaInicio?: string, fechaFin?: string) {

        const urlFinal = this.urls.dashboardVentasCompleto + `?idEmpresa=${idEmpresa}&anioSeleccionado=${anioSeleccionado}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerDashboardVentasMensuales(idEmpresa: string, anios: string) {

        const urlFinal = this.urls.dashboardVentasMensuales + `?idEmpresa=${idEmpresa}&anios=${anios}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerDatosDashboardVentas(IdEmpresa: string) {

        let urlFinal = this.urls.obtenerDatosDashboardVentas;

        urlFinal += `?IdEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }


    /// Compras

    verificarCatalogosBusquedaDocumentosCompras(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosBusquedaDocumentosCompras + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    revisarFacturaCompra(IdTransaccionComercial) {

        const urlFinal = this.urls.revisarFacturaCompra + `?IdTransaccionComercial=${IdTransaccionComercial}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    revisarDocumentoCompraNoFacturaCompra(IdTransaccionComercial) {

        const urlFinal = this.urls.revisarDocumentoCompraNoFacturaCompra + `?IdTransaccionComercial=${IdTransaccionComercial}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerCuentasPagarGeneral(cobranzaGeneral: CobranzaGeneral) {

        return this.post<JsonResponse>(this.urls.obtenerCuentasPagarGeneral, cobranzaGeneral, this.authService.token);
    }

    duplicarTransaccionComercialComprasCompleta(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.duplicarTransaccionComercialComprasCompleta, transaccionComercial, this.authService.token);
    }

    obtenerDetalleCXPPorTransaccionComercial(idTransaccionComercial: any) {

        let urlFinal = this.urls.obtenerDetalleCXPPorTransaccionComercial + `?IdTransaccionComercial=${idTransaccionComercial}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerCARGARXML(cargarXML: CARGARXML) {

        return this.post<JsonResponse>(this.urls.obtenerCARGARXML, cargarXML, this.authService.token);
    }

    actualizarCARGARXML(cargarXML: CARGARXML) {

        return this.post<JsonResponse>(this.urls.actualizarCargarXML, cargarXML, this.authService.token);
    }

    verificarCatalogosComprasEgresos(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosComprasEgresos + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    revisarNumeroDocumentoProveedor(transaccionComercial: TransaccionComercial) {

        return this.post<JsonResponse>(this.urls.revisarNumeroDocumentoProveedor, transaccionComercial, this.authService.token);
    }

    obtenerTransaccionComercialComprasDocumentosARelacionarPaginado(tamanioPagina: number, pagina: number,
        factura: boolean, compras: boolean, inventar: boolean,
        nombre: string, identificador: string,
        idEmpresa: string, IdTercero: string, IdProyecto: string,
        Ano: string, Mes: string, usuarioConectado: string, ClaveTipoTransaccion: string) {

        let urlFinal = this.urls.obtenerTransaccionComercialComprasDocumentosARelacionarPaginado + `?tamanioPagina=${tamanioPagina}&pagina=${pagina}`;

        if (nombre != undefined && nombre != null && nombre != '') {
            urlFinal += `&nombre=${nombre}`;
        }

        if (identificador != undefined && identificador != null && identificador != '') {
            urlFinal += `&identificador=${identificador}`;
        }

        urlFinal += `&idEmpresa=${idEmpresa}`;

        urlFinal += `&usuarioConectado=${usuarioConectado}`;

        if (IdProyecto != undefined && IdProyecto != null && IdProyecto != '') {
            urlFinal += `&IdProyecto=${IdProyecto}`;
        }

        if (IdTercero != undefined && IdTercero != null && IdTercero != '') {
            urlFinal += `&IdTercero=${IdTercero}`;
        }

        if (Ano != undefined && Ano != null && Ano != '') {
            urlFinal += `&Ano=${Ano}`;
        }

        if (Mes != undefined && Mes != null && Mes != '') {
            urlFinal += `&Mes=${Mes}`;
        }

        if (factura != undefined && factura != null) {
            urlFinal += `&factura=${factura}`;
        }

        if (compras != undefined && compras != null) {
            urlFinal += `&compras=${compras}`;
        }

        if (inventar != undefined && inventar != null) {
            urlFinal += `&inventar=${inventar}`;
        }

        if (ClaveTipoTransaccion != undefined && ClaveTipoTransaccion != null) {
            urlFinal += `&ClaveTipoTransaccion=${ClaveTipoTransaccion}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerCiudadEmpresa(ciudad: Ciudad) {

        return this.post<JsonResponse>(this.urls.obtenerCiudadEmpresa, ciudad, this.authService.token);
    }

    cargarDocumentoXML(documentoXML: DocumentoXML) {

        return this.post<JsonResponse>(this.urls.cargarDocumentoXML, documentoXML, this.authService.token);

    }

    obtenerCARGARXMLCompleto(cargarXML: CARGARXML) {

        return this.post<JsonResponse>(this.urls.obtenerCARGARXMLCompleto, cargarXML, this.authService.token);
    }

    verificarCatalogosCuentasPagar(IdPais: any, IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosCuentasPagar + `?idPais=${IdPais}&idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerPagoProveedorComplemento(filtros: {
        IdPagoCliente: any, IdEmpresa: any, IdTipoTransaccion: any,
        IdBanco: any, numeroDocumento: string,
        Fecha: string, FechaRegistroInicial: string, FechaRegistroFinal: string, activo: boolean, IdMoneda: any
    }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerPagoProveedorComplemento}?${queryString}`
            : this.urls.obtenerPagoProveedorComplemento;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    cancelarPagoProveedor(pagoProveedor: PagoProveedor) {

        return this.post<JsonResponse>(this.urls.cancelarPagoProveedor, pagoProveedor, this.authService.token);
    }

    obtenerPagoProveedorDetalle(pagoProveedorDetalle: PagoProveedorDetalle) {

        return this.post<JsonResponse>(this.urls.obtenerPagoProveedorDetalle, pagoProveedorDetalle, this.authService.token);
    }

    verificarCatalogosCargarXML(IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosCargarXML + `?IdEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    revisarDocumentoProveedor(formData: FormData) {

        return this.postFile<JsonResponse>(
            this.urls.revisarDocumentoProveedor,
            formData,
            this.authService.token
        );

    }

    agregarDocumentosProveedor(formData: FormData) {
        return this.postFile<JsonResponse>(
            this.urls.agregarDocumentosProveedor,
            formData,
            this.authService.token
        );
    }

    verificarCatalogosComprobantesPolizas(IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosComprobantesPolizas + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerMovimientosContablesAgrupado(IdEmpresa: string, IdTipoTransaccion: string,
        FechaInicio: string, FechaFinal: string) {

        let urlFinal = this.urls.obtenerMovimientosContablesAgrupado + `?IdEmpresa=${IdEmpresa}`;

        if (IdTipoTransaccion != undefined && IdTipoTransaccion != null && IdTipoTransaccion != '') {
            urlFinal += `&IdTipoTransaccion=${IdTipoTransaccion}`;
        }

        if (FechaInicio != undefined && FechaInicio != null) {
            urlFinal += `&FechaInicio=${FechaInicio}`;
        }

        if (FechaFinal != undefined && FechaFinal != null) {
            urlFinal += `&FechaFinal=${FechaFinal}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerDetalleSaldoContable(IdEmpresa: string, YY: number, MM: number, IdCuentaContable?: string,
        IdPoliza?: string, Documento?: string) {

        let urlFinal = this.urls.obtenerDetalleSaldoContable + `?IdEmpresa=${IdEmpresa}&YY=${YY}&MM=${MM}`;

        if (IdCuentaContable != undefined && IdCuentaContable != null && IdCuentaContable != '') {
            urlFinal += `&IdCuentaContable=${IdCuentaContable}`;
        }

        if (IdPoliza != undefined && IdPoliza != null && IdPoliza != '') {
            urlFinal += `&IdPoliza=${IdPoliza}`;
        }

        if (Documento != undefined && Documento != null && Documento != '') {
            urlFinal += `&Documento=${Documento}`;
        }

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    revisarPolizaContable(IdEmpresa: string, IdPolizaContable: string, Documento: number) {

        let urlFinal = this.urls.revisarPolizaContable + `?IdEmpresa=${IdEmpresa}&IdPolizaContable=${IdPolizaContable}&Documento=${Documento}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerBalanceTimbres(filtros: { IdEmpresa: string, esActualizacionEmpresa?: boolean }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerbalanceTimbres}?${queryString}`
            : this.urls.obtenerbalanceTimbres;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    verificarCatalogosEntradasTraslados(IdEmpresa: any) {

        const urlFinal = this.urls.verificarCatalogosEntradasTraslados + `?idEmpresa=${IdEmpresa}`;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    /// config Service 

    guardarImagen(empresaConfiguracionImagenes: EmpresaConfiguracionImagenes) {

        return this.post<JsonResponse>(this.urls.guardarImagen, empresaConfiguracionImagenes, this.authService.token);
    }

    eliminarImagen(empresaConfiguracionImagenes: EmpresaConfiguracionImagenes) {

        return this.post<JsonResponse>(this.urls.eliminarImagen, empresaConfiguracionImagenes, this.authService.token);
    }

    // Copomex

    // obtenerColoniasXCPCopomex(cp: string) {

    //     return this.getSinToken<JsonResponseDireccion>(this.urls.obtenerColoniasXCPCopomex + cp + '?token=' + environment.tokenCopomex);
    // }

    // obtenerInfoXCP(cp: string) {

    //     return this.getSinToken<JsonResponseDireccion[]>(this.urls.obtenerInfoXCP + cp + '?token=' + environment.tokenCopomex);
    // }

    // ComercioExterior

    obtenerColoniasPorCodigoPostal(filtros: {
        codigoPostal: string
    }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerColoniasPorCodigoPostal}?${queryString}`
            : this.urls.obtenerColoniasPorCodigoPostal;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerInfoCodigoPostal(filtros: {
        codigoPostal: string
    }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerInfoCodigoPostal}?${queryString}`
            : this.urls.obtenerInfoCodigoPostal;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerEstados(filtros: {
        pais: string
    }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerEstados}?${queryString}`
            : this.urls.obtenerEstados;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerMunicipios(filtros: {
        estado: string
    }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerMunicipios}?${queryString}`
            : this.urls.obtenerMunicipios;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerLocalidades(filtros: {
        estado: string
    }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerLocalidades}?${queryString}`
            : this.urls.obtenerLocalidades;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    obtenerCatalogoComercioExterior(filtros: {
        paisEmisor: string,
        codigoPostal: string
    }) {

        const params = new URLSearchParams();

        Object.entries(filtros).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });

        const queryString = params.toString();
        const urlFinal = queryString
            ? `${this.urls.obtenerCatalogoComercioExterior}?${queryString}`
            : this.urls.obtenerCatalogoComercioExterior;

        return this.get<JsonResponse>(urlFinal, this.authService.token);
    }

    inicializarCatalogo(catalogo: Array<any>, asignarElementoInicial: Function, id: string, valor: string, tituloPrimerElemento?: string) {

        const elementoInicial = {
            [id]: 0,
            [valor]: tituloPrimerElemento != null ? tituloPrimerElemento : 'Selecciona una opción'
        };

        catalogo.splice(0, catalogo.length);
        catalogo.push(elementoInicial);

        asignarElementoInicial(elementoInicial);
    }

    inicializarCatalogoSoloUnValor(catalogo: Array<any>, asignarElementoInicial: Function, valor: string, tituloPrimerElemento?: string) {

        const elementoInicial = {
            [valor]: tituloPrimerElemento != null ? tituloPrimerElemento : 'Selecciona una opción'
        };

        catalogo.splice(0, catalogo.length);
        catalogo.push(elementoInicial);

        asignarElementoInicial(elementoInicial);
    }
}